import { documentDirectory } from '../../utils/fileSystemCompat'
import React, { useEffect, useState, useRef } from 'react'
import * as FileSystem from 'expo-file-system'
import {
    Dimensions,
    FlatList,
    Image,
    Platform,
    ScrollView,
    StyleSheet,
    Text,
    TouchableOpacity,
    View,
} from 'react-native'
import { useNavigation, useRoute } from '../../hooks/useWebNavigation'
import { FlashList } from '@shopify/flash-list'
import { EvilIcons, Feather, Ionicons, SimpleLineIcons } from '@expo/vector-icons'
import RenderHTML from 'react-native-render-html'
import { useWindowDimensions } from 'react-native'
import NetInfo from '@react-native-community/netinfo'
import { getConection } from '../appBar/context/HeaderContext'
import {
    get_course_by_id,
    update_status_local_content,
    // update_status_local_course,
    update_course_local,
    get_evaluation_by_id,
    get_contents,
    LEARNING_STORE_NAMES,
} from '../../db/learning'
import MediaComponent from '../customUtils/Components/MediaComponent'
import { LABEL_STATE, LABElS, LEARNING_STATUS, OPTIONS } from './constants/index'
import { useFunctions } from './hooks/useFunctions'
import { module_structure_update, save_progress_training_request } from './services'
import { save_progress_training_local } from '../../db/learning/index'
import { isAndroid, isIOS } from '../../utils/platformUtils'
import { openDB } from '../../db/indexDB'
import { Loader } from '../customUtils/Components/Loader'
import theme from '../../../theme'
import {
    AlertAssesment,
    AlertCompleteNoEvaluation,
} from './components/AlertAssesment'
import { useDeviceStore } from '../../redux/zustand/deviceInfoStore'
import * as Progress from 'react-native-progress'
import styles from './CourseHomeStyles'
import TermsAndConditions from '../modals/TermsAndConditions'
import { BottomSheetAlert } from '../modals/BottomSheetAlert'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import { apiUrl } from '../../config/config'
import { fetchAuthSession } from 'aws-amplify/auth'
import {
    cleanDoubleQuotedString,
    getAuthToken,
    hasValue,
} from '../../utils/functions.utils'
import { placeholderLearning } from '../customUtils/Constants'
import { LinearGradient } from 'expo-linear-gradient'
import { TrackingServices } from '../../../database/tracking.database'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { colorButtonTextEnabled, colorIcon } from '../../../themeConstants'
import Constants from 'expo-constants'
import { CachedImage } from '../customUtils/Components/CachedImage'
import {
    deletePathFile,
    downloadAndUnzipAllFiles,
    downloadContent,
    getCourseIdByURL,
    getNameUrl,
    getVersionByURL,
    getVersionLearningByURL,
    searchFilebyName,
    setKeepAwake,
    verifyAndDeleteZip,
} from '../../utils/functions.utils'
import { UserServices } from '../../../database/user.database'
import ModalDownloadCourse from '../modals/ModalDownloadCourse'
import { getAlert } from '../appBar/context/AlertsContext'
import { useBreakpoint } from '@/redux/zustand/useDimensionStore'
import { useFocusEffect } from '@react-navigation/native'
import { subscribeProgressUpdate, getProgressVersion } from './progressBus'
import { StorageAdapter } from '../../utils/AsyncStorage'
import { ASYNC_STORAGE_KEYS } from '../stores/constants/constants.storage'
import { useTermsAndConditionsStore } from '../../redux/zustand/termsAndContionsStore'
import {
    debug as logDebug,
    info as logInfo,
    warn as logWarn,
    error as logError,
    redact as logRedact,
} from '../../utils/logger'
import { getReprobatedText } from './hooks/getReprobatedText'
import { useLearningStore } from '../../redux/zustand/useLearningCourse.ts'
import { useAndroidNavBarHeight } from '../customUtils/hooks/useAndroidNavBarHeight'
import { update_status_local_course } from '../../../db-sqlite/repositories/learning.repository'

const statusColors = {
    [LEARNING_STATUS.BLOCKED]: theme.colors.colorLocked,
    [LEARNING_STATUS.PENDIENTE]: theme.colors.colorPending,
    [LEARNING_STATUS.VIEWED]: theme.colors.colorSeen,
    [LEARNING_STATUS.COMPLETED]: theme.colors.colorApproved,
    [LEARNING_STATUS.REPROBADO]: theme.colors.colorRetry,
    [LEARNING_STATUS.PENDING_CONNECTION]: theme.colors.colorPending,
    [LEARNING_STATUS.IN_PROGRESS]: theme.colors.colorInProgress,
}

const { width } = Dimensions.get('window')
export const translateLabel = (label, languageFile) => {
    if (!languageFile) return ''
    switch (label) {
        case LABEL_STATE.label_course:
            return languageFile.continue_course
        case LABEL_STATE.label_evaluation:
            return languageFile.evaluate_me
        case LABEL_STATE.label_course_complete:
            return languageFile.retry
        case LABEL_STATE.label_course_pending:
            return languageFile.sync_pending
        default:
            return ''
    }
}
const isWeb = Platform.OS === 'web'
const CourseHome = () => {
    const currentCourse_store = useLearningStore((state) => state.currentCourse)
    const setCurrentCourse_store = useLearningStore(
        (state) => state.setCurrentCourse,
    )
    const clearCourse_store = useLearningStore((state) => state.clearCourse)
    const clearModuleContext_store = useLearningStore(
        (state) => state.clearModuleContext,
    )

    const { languageFile } = getLanguage()
    const { setAlert, closeAlert } = getAlert()
    const route = useRoute()
    const navigation = useNavigation()
    const routeParams = route && route.params ? route.params : {}
    // const item = routeParams?.item
    const item = route?.params?.item
    const array_cursos = routeParams?.array_cursos || []
    // const token = useSelector((state) => state.auth.authToken)
    const [token, setToken] = useState(null)
    const { deviceId } = useDeviceStore()
    const [labelNextCourse, setLabelNextCourse] = useState(LABEL_STATE.label_course)
    const [reloadCounter, setReloadCounter] = useState(0)
    // const [curso, setCurso] = useState(item || null)
    // const [curso, setCurso] = useState(currentCourse_store || item || null)
    const [curso, setCurso] = useState(() => {
        const courseFromStore = currentCourse_store || item || null
        return normalizeCourse(courseFromStore)
    })

    const modules = curso && Array.isArray(curso.moduls) ? curso.moduls : []

    const [isLoading, setIsLoading] = useState(true)

    const [porcentanje_aprobacion, setPorcentanje_aprobacion] = useState(
        curso &&
            curso.evaluations &&
            curso.evaluations.length > 0 &&
            curso.evaluations[0] &&
            curso.evaluations[0].assessmentResult != null
            ? curso.evaluations[0].assessmentResult
            : null,
    )

    const [progress_percentage, setProgressPercentage] = useState(0)

    const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const snapPoints = ['60%']
    const acceptTermsAndConditions = useTermsAndConditionsStore(
        (state) => state.acceptTerms,
    )

    const handle_terms = (txt, version) => {
        try {
            logInfo('TTCC', 'open modal (course)', {
                courseId: String(get_curso?._id ?? ''),
                version: String(version ?? ''),
            })
        } catch {}
        openBottomSheet(
            <TermsAndConditions
                termsText={txt}
                onAccept={acceptTerms}
                closeSearch={() => closeBottomSheet(true)}
                version={version}
            />,
            snapPoints,
            false,
        )
    }

    const set_label = async (isCompleted, course) => {
        try {
            // Normalizar posible campo singular `evaluation` a `evaluations`
            if (!course.evaluations && course.evaluation) {
                course.evaluations = Array.isArray(course.evaluation)
                    ? course.evaluation
                    : [course.evaluation]
            }

            if (typeof course.evaluations === 'string') {
                try {
                    course.evaluations = JSON.parse(course.evaluations)
                } catch {
                    // Si no se puede parsear, dejar como array con el string (posible id)
                    course.evaluations = [course.evaluations]
                }
            }

            // console.log('[DEBUG set_label] course.evaluations normalized:', JSON.stringify(course.evaluations, null, 2))
            // console.log('[DEBUG WEB set_label] course.evaluations normalized (WEB):', JSON.stringify(course.evaluations, null, 2))

            if (isCompleted) {
                // Todos los módulos completos
                console.log(
                    '🚀 realizo todos los modulos ~ isCompleted:',
                    isCompleted,
                    course.status,
                )
                if (course.evaluations && course.evaluations.length > 0) {
                    console.log('el curso tiene evaluacion')
                    if (course.status === LEARNING_STATUS.COMPLETED) {
                        setLabelNextCourse(LABEL_STATE.label_course_complete)
                        if (course.assessmentResult && isWeb)
                            setPorcentanje_aprobacion(
                                course.assessmentResult.toString(),
                            )
                        console.log(
                            '[DEBUG set_label] set labelNextCourse ->',
                            LABEL_STATE.label_course_complete,
                        )
                    } else if (
                        course.status === LEARNING_STATUS.PENDING_CONNECTION
                    ) {
                        console.log('SIGUIENTE PENDING_CONNECTION:---> curso')
                        setLabelNextCourse(LABEL_STATE.label_course_pending)
                        console.log(
                            '[DEBUG set_label] set labelNextCourse ->',
                            LABEL_STATE.label_course_pending,
                        )
                    } else {
                        console.log('SIGUIENTE CONTENIDO:---> EVALUACION')
                        setLabelNextCourse(LABEL_STATE.label_evaluation)
                        console.log(
                            '[DEBUG set_label] set labelNextCourse ->',
                            LABEL_STATE.label_evaluation,
                        )
                    }
                } else {
                    // Curso sin evaluación: marcar como completo
                    console.log('-------------- no tengo evaluacion....')
                    setLabelNextCourse(LABEL_STATE.label_course_complete)
                    console.log(
                        '[DEBUG set_label] set labelNextCourse ->',
                        LABEL_STATE.label_course_complete,
                    )
                    if (course.status !== LEARNING_STATUS.COMPLETED) {
                        // const db = await openDB()
                        await update_status_local_course(
                            course._id,
                            LEARNING_STATUS.COMPLETED,
                        )
                        // Sincronizar con el servidor para que el home refleje el cambio
                        try {
                            const netState = await NetInfo.fetch()
                            if (netState.isConnected) {
                                const session = await fetchAuthSession()
                                const authToken =
                                    session.tokens.accessToken.toString()
                                const moduls_for_server = (course.moduls || []).map(
                                    (m) => ({
                                        _id: m._id,
                                        status: m.status,
                                    }),
                                )
                                await save_progress_training_request(
                                    {
                                        course_id: course._id,
                                        course_status: LEARNING_STATUS.COMPLETED,
                                        moduls: JSON.stringify(moduls_for_server),
                                        authToken: authToken,
                                    },
                                    {
                                        authToken: authToken,
                                        device_key: deviceId,
                                        table: 'training_courses_caches',
                                    },
                                )
                            }
                        } catch (e) {
                            console.warn(
                                '[set_label] Error syncing course COMPLETED to server:',
                                e,
                            )
                        }
                    } else {
                        setPorcentanje_aprobacion('100')
                    }
                    try {
                        const isLastCourse = await find_ultimo_curso(
                            array_cursos,
                            course,
                        )
                        if (isLastCourse) {
                            // noop: actualizar categoría si aplica
                        }
                    } catch {}
                }
            } else {
                // Curso NO completado aún: no mostrar "Evaluarme" hasta que todos los módulos estén completos
                console.log(
                    '🚀 curso en progreso/no completo --isCompleted:',
                    isCompleted,
                    'status:',
                    course.status,
                )
                if (course.status === LEARNING_STATUS.COMPLETED) {
                    setLabelNextCourse(LABEL_STATE.label_course_complete)
                    console.log(
                        '[DEBUG set_label] set labelNextCourse ->',
                        LABEL_STATE.label_course_complete,
                    )
                } else if (course.status === LEARNING_STATUS.REPROBADO) {
                    // Permitir reintentar evaluación si reprobado
                    setLabelNextCourse(LABEL_STATE.label_evaluation)
                    console.log(
                        '[DEBUG set_label] set labelNextCourse ->',
                        LABEL_STATE.label_evaluation,
                    )
                } else {
                    if (
                        course.status === LEARNING_STATUS.PENDIENTE &&
                        course.moduls.some(
                            (m) =>
                                m.status !== LEARNING_STATUS.BLOCKED &&
                                m.status !== LEARNING_STATUS.PENDIENTE,
                        )
                    ) {
                        try {
                            // const db = await openDB()
                            await update_status_local_course(
                                course._id,
                                LEARNING_STATUS.IN_PROGRESS,
                            )
                            await module_structure_update(db, [], course)
                        } catch {}
                    }
                    setLabelNextCourse(LABEL_STATE.label_course)
                    console.log(
                        '[DEBUG set_label] set labelNextCourse ->',
                        LABEL_STATE.label_course,
                    )
                }
            }
        } catch (error) {
            console.error('93 error en set_label: ', error)
        }
    }

    const find_ultimo_curso = async (array_cursos, curso) => {
        let isLastCourse = false

        if (array_cursos && array_cursos.length > 0) {
            const ultimo_curso = array_cursos[array_cursos.length - 1]

            if (curso._id.toString() === ultimo_curso._id.toString()) {
                // estoy en el utlimo curso
                console.log('Estoy en el utlimo curso..............')

                if (curso.evaluation && curso.evaluation.length > 0) {
                    console.log(
                        '🚀 ~ Estoy en el utlimo curso............. TENGO EVALUACION:',
                        curso,
                    )

                    // * el curso tiene evaluacion, debo realizar el update en la evaluacion
                } else {
                    //* el curso no tiene evaluacion, realizo el update de categoria ahora

                    console.log(
                        '🚀 ~ Estoy en el utlimo curso............. NO TENGO EVALUACION:',
                        curso,
                    )

                    isLastCourse = true

                    // setIsLastCourse(true)
                    // const data = [
                    //   {
                    //     category: curso, // todo como obtengo la categoria ?
                    //     status: LEARNING_STATUS.COMPLETED,
                    //   }
                    // ]

                    // update_status_local_category(data)
                }
            }
        }

        return isLastCourse
    }

    const getTerms = async () => {
        try {
            const netInfoState = await NetInfo.fetch()
            let data
            let fetch_error = false
            const courseId = String(curso?._id || item?._id || '')
            if (!courseId) {
                // No hay curso aún, no solicitamos términos
                return
            }
            if (connectedStable) {
                const session = await fetchAuthSession()
                const authToken = session.tokens.accessToken.toString()
                const response = await fetch(`${apiUrl}/get_terms_and_conditions`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: String(authToken),
                        course_id: courseId,
                    },
                })

                if (!response.ok) {
                    data = { status: 0 }
                    fetch_error = true
                }

                if (!fetch_error) {
                    data = await response.json()
                    try {
                        logDebug('TTCC', 'get_terms_and_conditions OK', {
                            courseId: String(get_curso?._id ?? ''),
                            status: data?.status,
                            hasTerms: !!data?.single?.terms,
                            version: String(data?.single?.version ?? ''),
                        })
                    } catch {}
                    if (data.status == 1) {
                        const version = String(data?.single?.version ?? '')
                        const cacheKey = `${ASYNC_STORAGE_KEYS.TERMS_AND_CONDITIONS_ACCEPTED}:${String(get_curso._id)}:${version}`
                        try {
                            const accepted = await StorageAdapter.getItem(cacheKey)
                            if (accepted === 'true') {
                                try {
                                    logInfo(
                                        'TTCC',
                                        'already accepted (course+version) skip modal',
                                        {
                                            courseId: String(get_curso?._id ?? ''),
                                            version,
                                        },
                                    )
                                } catch {}
                                // Ya aceptado localmente para esta versión: no mostrar
                            } else {
                                try {
                                    logInfo(
                                        'TTCC',
                                        'show modal (not accepted yet)',
                                        {
                                            courseId: String(get_curso?._id ?? ''),
                                            version,
                                        },
                                    )
                                } catch {}
                                handle_terms(data?.single?.terms, version)
                            }
                        } catch {
                            try {
                                logWarn('TTCC', 'cache read error, showing modal', {
                                    courseId: String(get_curso?._id ?? ''),
                                    version,
                                })
                            } catch {}
                            handle_terms(data?.single?.terms, version)
                        }
                        // Guardar último TTCC para fallback offline
                        try {
                            const lastKey = `${ASYNC_STORAGE_KEYS.TERMS_AND_CONDITIONS_LAST}:${String(get_curso._id)}`
                            await StorageAdapter.setItem(
                                lastKey,
                                JSON.stringify({
                                    version,
                                    terms: String(data?.single?.terms ?? ''),
                                }),
                            )
                        } catch {}
                    }
                }
            }
            // Offline: mostrar último TTCC si existe y no está aceptado
            if (!netInfoState.isConnected) {
                try {
                    const lastKey = `${ASYNC_STORAGE_KEYS.TERMS_AND_CONDITIONS_LAST}:${String(get_curso._id)}`
                    const cached = await StorageAdapter.getItem(lastKey)
                    if (cached) {
                        const parsed = JSON.parse(cached)
                        const version = String(parsed?.version ?? '')
                        const cacheKey = `${ASYNC_STORAGE_KEYS.TERMS_AND_CONDITIONS_ACCEPTED}:${String(get_curso._id)}:${version}`
                        const accepted = await StorageAdapter.getItem(cacheKey)
                        if (accepted !== 'true' && parsed?.terms) {
                            try {
                                logInfo('TTCC', 'offline fallback show modal', {
                                    courseId: String(get_curso?._id ?? ''),
                                    version,
                                })
                            } catch {}
                            handle_terms(String(parsed.terms), version)
                        }
                    }
                } catch {}
            }
        } catch (error) {
            try {
                logError('TTCC', 'getTerms error (course)', error)
            } catch {}
        }
    }

    const acceptTerms = async (version) => {
        //trackear aca
        TrackingServices.addTracking(
            get_curso._id,
            'accept_terms_and_conditions',
            'terms_and_conditions_acceptances',
        )
        try {
            const netInfoState = await NetInfo.fetch()
            let data
            let fetch_error = false
            if (netInfoState.isConnected) {
                const session = await fetchAuthSession()
                const authToken = session.tokens.accessToken.toString()
                const response = await fetch(
                    `${apiUrl}/accept_terms_and_conditions`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: String(authToken),
                            course_id: String(get_curso._id),
                            version: String(version ?? ''),
                        },
                    },
                )

                if (!response.ok) {
                    data = { status: 0 }
                    fetch_error = true
                }

                if (!fetch_error) {
                    data = await response.json()
                    // Si el backend confirma aceptación, cachear localmente por version y curso
                    try {
                        const ver = String(version ?? data?.single?.version ?? '')
                        if (data?.status == 1 && ver) {
                            const cacheKey = `${ASYNC_STORAGE_KEYS.TERMS_AND_CONDITIONS_ACCEPTED}:${courseId}:${ver}`
                            await StorageAdapter.setItem(cacheKey, 'true')
                            // Actualizar store global para que otras vistas lo sepan
                            try {
                                acceptTermsAndConditions()
                                logInfo('TTCC', 'accepted (course)', {
                                    courseId: courseId,
                                    version: ver,
                                })
                            } catch {}
                        }
                    } catch {}
                }
            }
        } catch (error) {
            try {
                logError('TTCC', 'acceptTerms error (course)', error)
            } catch {}
        }
    }

    /* ---------------------------------------------------------
   1) Al montar limpiamos el contexto
--------------------------------------------------------- */
    useEffect(() => {
        clearModuleContext_store()
    }, [])

    /* ---------------------------------------------------------
   2) Entrada del curso:
      - Si viene por params → guardarlo en store
      - Si existe en store → usarlo como fuente
--------------------------------------------------------- */
    useEffect(() => {
        if (
            item?._id &&
            (!currentCourse_store || currentCourse_store._id !== item._id)
        ) {
            console.log('💾 [CourseHome] Saving course to store:', item._id)
            setCurrentCourse_store(item)
            setCurso(item)
            return
        }

        if (
            currentCourse_store?._id &&
            (!curso || curso._id !== currentCourse_store._id)
        ) {
            console.log(
                '📚 [CourseHome] Using course from store:',
                currentCourse_store._id,
            )
            setCurso(normalizeCourse(currentCourse_store))
        }
    }, [item?._id, currentCourse_store?._id])

    /* ---------------------------------------------------------
   3) Cuando cambia el store del mismo curso → refrescar estado local
   (assessmentResult / status)
--------------------------------------------------------- */
    useEffect(() => {
        if (!currentCourse_store?._id) return
        if (currentCourse_store._id !== curso?._id) return

        const storeAssessment = currentCourse_store.assessmentResult
        const storeStatus = currentCourse_store.status

        const localAssessment = curso?.assessmentResult
        const localStatus = curso?.status

        if (storeAssessment === localAssessment && storeStatus === localStatus) {
            return
        }

        console.log('📊 [CourseHome] Store updated, refreshing labels')

        setCurso((prev) => {
            const updated = {
                ...prev,
                assessmentResult: storeAssessment,
                status: storeStatus,
            }

            const isCompleted =
                Array.isArray(updated?.moduls) &&
                updated.moduls.every((m) => m.status === LEARNING_STATUS.COMPLETED)

            set_label(isCompleted, updated)

            return updated
        })
    }, [
        currentCourse_store?.assessmentResult,
        currentCourse_store?.status,
        currentCourse_store?._id,
    ])

    /* ---------------------------------------------------------
   5) Derivados: porcentaje de progreso
--------------------------------------------------------- */
    useEffect(() => {
        try {
            const mods = Array.isArray(curso?.moduls) ? curso.moduls : []
            const total = mods.length

            if (total === 0) {
                setProgressPercentage(0)
                return
            }

            const approved = mods.filter(
                (m) => (m?.status ?? 0) === LEARNING_STATUS.COMPLETED,
            ).length

            setProgressPercentage((approved / total) * 100)
        } catch {}
    }, [curso])

    /* ---------------------------------------------------------
   6) Focus: si faltan módulos, refrescar desde DB
--------------------------------------------------------- */
    useFocusEffect(
        React.useCallback(() => {
            console.log('[CourseHome] Screen focused, checking modules')

            if (
                !curso?.moduls ||
                !Array.isArray(curso.moduls) ||
                curso.moduls.length === 0
            ) {
                console.warn('[CourseHome] Módulos vacíos, refrescando desde DB')
                fetchDataNew().catch(() => {})
            }
        }, [curso?._id]), // SOLO depende del ID para evitar loops
    )

    /* ---------------------------------------------------------
   7) Evento de navegación: limpiar store al salir
--------------------------------------------------------- */
    useEffect(() => {
        const unsubscribe = navigation.addListener('beforeRemove', (e) => {
            if (
                e.data.action.type === 'GO_BACK' ||
                (e.data.action.type === 'POP' &&
                    e.data.action.target ===
                        navigation.dangerouslyGetParent?.()?.getState?.()?.key)
            ) {
                clearCourse_store()
                clearModuleContext_store?.()
            }
        })

        return () => unsubscribe && unsubscribe()
    }, [navigation])

    const fetchDataNew = async () => {
        try {
            setIsLoading(true)
            // const courseId = String(curso?._id || item?._id || '')
            const courseId = String(
                curso?._id || item?._id || currentCourse_store?._id || '',
            )
            // console.log('[DEBUG CourseHome] fetchDataNew - item recibido:', JSON.stringify(item, null, 2))
            // console.log('[DEBUG CourseHome] fetchDataNew - curso actual:', JSON.stringify(curso, null, 2))
            if (!courseId) {
                // Sin curso aún, no cargamos desde DB
                return
            }
            const database = await openDB()
            const course = await get_course_by_id(database, courseId)
            console.log('coursecoursecourse => get_course_by_id => ', course)
            //const course = await LearningServices.get_course_by_id(courseId)
            // setCurso(course)
            // return
            // console.log('[DEBUG CourseHome] fetchDataNew - course from DB:', JSON.stringify(course, null, 2))

            // Si no encontramos el curso en la DB (puede ocurrir justo después de una carga remota),
            // usamos el `item` que vino en los params como fallback para evitar pantalla vacía.
            // const effectiveCourse = course || item || null
            // ✅ Si hay curso en DB, actualizarlo; si no, mantener el del store
            const effectiveCourse = course || currentCourse_store || item || null
            if (effectiveCourse) {
                setCurso(effectiveCourse)
                setCurrentCourse_store(effectiveCourse) // Actualizar store
            }
            // console.log('[DEBUG CourseHome] fetchDataNew - effectiveCourse:', JSON.stringify(effectiveCourse, null, 2))

            // Normalizar moduls si vienen como string (caso de datos recién descargados)
            try {
                if (effectiveCourse && typeof effectiveCourse.moduls === 'string') {
                    effectiveCourse.moduls = JSON.parse(effectiveCourse.moduls)
                }
            } catch (e) {
                console.warn('[CourseHome] error parsing moduls:', e)
            }

            console.log(
                '[DEBUG CourseHome] Antes de reconstruir - moduls:',
                effectiveCourse?.moduls,
                'isArray:',
                Array.isArray(effectiveCourse?.moduls),
                'length:',
                effectiveCourse?.moduls?.length,
                'first type:',
                typeof effectiveCourse?.moduls?.[0],
            )
            // Si effectiveCourse.moduls es array de strings (IDs), intentar reconstruir con objetos completos
            if (
                effectiveCourse &&
                Array.isArray(effectiveCourse.moduls) &&
                effectiveCourse.moduls.length > 0 &&
                (typeof effectiveCourse.moduls[0] === 'string' ||
                    typeof effectiveCourse.moduls[0] === 'object')
            ) {
                console.log('[DEBUG CourseHome] Entrando a reconstruir moduls')
                try {
                    const contents = await get_contents(database)
                    // console.log('[DEBUG CourseHome] Reconstruyendo moduls - contents encontrados:', contents.length)
                    effectiveCourse.moduls = effectiveCourse.moduls
                        .map((module) => {
                            // console.log(
                            //     '[DEBUG CourseHome] Analizando módulo:',
                            //     JSON.stringify(module, null, 2),
                            // )
                            // Caso web: módulo es objeto y su _id es objeto con title
                            if (
                                typeof module === 'object' &&
                                module !== null &&
                                typeof module._id === 'object' &&
                                module._id !== null &&
                                module._id.title
                            ) {
                                if (typeof module._id.media_slides === 'string') {
                                    try {
                                        module._id.media_slides = JSON.parse(
                                            module._id.media_slides,
                                        )
                                    } catch {}
                                }
                                return { ...module._id, _id: module._id._id }
                            }
                            // Caso app: módulo es objeto con _id y title
                            if (
                                typeof module === 'object' &&
                                module !== null &&
                                module._id &&
                                module.title
                            ) {
                                if (typeof module.media_slides === 'string') {
                                    try {
                                        module.media_slides = JSON.parse(
                                            module.media_slides,
                                        )
                                    } catch {}
                                }
                                return module
                            }
                            // Caso ID: buscar en contents
                            if (typeof module === 'string') {
                                const content = contents.find(
                                    (c) => c._id === module,
                                )
                                if (content) {
                                    return content
                                }
                            }
                            // Si no se puede reconstruir, crear stub
                            return {
                                _id:
                                    typeof module === 'object' &&
                                    module !== null &&
                                    module._id
                                        ? module._id
                                        : module,
                                title: 'Módulo no encontrado',
                                description_short: 'Contenido no disponible',
                                status: 0,
                                media_slides: [],
                                evaluations: [],
                            }
                        })
                        .filter((module) => module !== null)
                    // console.log('[DEBUG CourseHome] moduls reconstruidos:', JSON.stringify(effectiveCourse.moduls, null, 2))
                } catch (e) {
                    console.warn('[CourseHome] Error reconstruyendo moduls:', e)
                    effectiveCourse.moduls = effectiveCourse.moduls.map(
                        (module) => ({
                            _id:
                                typeof module === 'object' &&
                                module !== null &&
                                module._id
                                    ? module._id
                                    : module,
                            title: 'Módulo',
                            description_short: 'Contenido',
                            status: 0,
                            media_slides: [],
                            evaluations: [],
                        }),
                    )
                }
            } else {
                console.log('[DEBUG CourseHome] No entra a reconstruir moduls')
            }

            // Manejar course.evaluations que podría ser string, array o vacío
            let course_evaluations = []
            if (effectiveCourse && effectiveCourse?.evaluations) {
                try {
                    // Si ya es un array, usarlo directamente
                    if (Array.isArray(effectiveCourse.evaluations)) {
                        course_evaluations = effectiveCourse.evaluations
                    }
                    // Si es string, intentar parsearlo
                    else if (
                        typeof effectiveCourse.evaluations === 'string' &&
                        effectiveCourse.evaluations.trim() !== ''
                    ) {
                        course_evaluations = JSON.parse(effectiveCourse.evaluations)
                    }
                } catch (parseError) {
                    console.error(
                        '[CourseHome] Error parsing evaluations:',
                        parseError,
                        'Raw value:',
                        effectiveCourse.evaluations,
                    )
                    course_evaluations = []
                }
            }

            if (course_evaluations && course_evaluations.length > 0) {
                try {
                    // Si estamos en web, usar las evaluaciones tal como vienen en el objeto
                    if (isWeb) {
                        const parsed = course_evaluations
                            .map((ev) => {
                                if (!ev) return null
                                if (typeof ev === 'string' && ev.trim() !== '') {
                                    // Mantener strings (IDs) tal cual; solo parsear si parecen JSON
                                    const t = ev.trim()
                                    if (
                                        (t.startsWith('{') && t.endsWith('}')) ||
                                        (t.startsWith('[') && t.endsWith(']'))
                                    ) {
                                        try {
                                            return JSON.parse(ev)
                                        } catch {
                                            return ev
                                        }
                                    }
                                    return ev
                                }
                                if (typeof ev === 'object') {
                                    if (typeof ev.type_assessment === 'string') {
                                        try {
                                            ev.type_assessment = JSON.parse(
                                                ev.type_assessment,
                                            )
                                        } catch {}
                                    }
                                    if (typeof ev.questions === 'string') {
                                        try {
                                            ev.questions = JSON.parse(ev.questions)
                                        } catch {}
                                    }
                                    if (typeof ev.survey === 'string') {
                                        try {
                                            ev.survey = JSON.parse(ev.survey)
                                        } catch {}
                                    }
                                }
                                return ev
                            })
                            .filter((e) => e != null)

                        effectiveCourse.evaluations = parsed
                    } else {
                        // En apps (no web) reconstruimos las evaluaciones desde la DB usando los IDs
                        const new_evaluations = []
                        for (const evaluation of course_evaluations) {
                            let eva = await get_evaluation_by_id(
                                database,
                                evaluation,
                            )
                            // Si la evaluación tiene campos stringificados, deserializarlos
                            if (eva) {
                                if (typeof eva.type_assessment === 'string') {
                                    try {
                                        eva.type_assessment = JSON.parse(
                                            eva.type_assessment,
                                        )
                                    } catch {}
                                }
                                if (typeof eva.questions === 'string') {
                                    try {
                                        eva.questions = JSON.parse(eva.questions)
                                    } catch {}
                                }
                                if (typeof eva.survey === 'string') {
                                    try {
                                        eva.survey = JSON.parse(eva.survey)
                                    } catch {}
                                }
                                // console.log('[DEBUG] Evaluación parseada desde DB:', JSON.stringify(eva, null, 2))
                                new_evaluations.push(eva)
                            } else {
                                // omitimos evaluaciones no encontradas en la DB
                                console.log(
                                    '[DEBUG] Evaluación no encontrada en DB para id:',
                                    evaluation,
                                )
                            }
                        }

                        effectiveCourse.evaluations = new_evaluations.filter(
                            (e) => e != null,
                        )
                    }
                } catch (error) {
                    console.error('148 error en course.evaluations: ', error)
                }
            }
            // console.log('[DEBUG CourseHome] effectiveCourse.moduls after normalization:', JSON.stringify(effectiveCourse?.moduls, null, 2))
            // console.log('[DEBUG CourseHome] effectiveCourse.evaluations after normalization:', JSON.stringify(effectiveCourse?.evaluations, null, 2))
            // Log when the Home carga y la evaluación ya está disponible
            try {
                if (
                    effectiveCourse &&
                    effectiveCourse.evaluations &&
                    effectiveCourse.evaluations.length > 0
                ) {
                    const ev0 = effectiveCourse.evaluations[0]
                    const evId =
                        ev0 && (ev0._id || ev0.id) ? String(ev0._id || ev0.id) : null
                    const evResult =
                        ev0 && (ev0.assessmentResult || ev0.score || ev0.result)
                            ? (ev0.assessmentResult ?? ev0.score ?? ev0.result)
                            : null
                    // console.log('[CourseHome] Home loaded — evaluation present', {
                    //     courseId: courseId,
                    //     evaluationId: evId,
                    //     assessmentResult: evResult,
                    // })
                } else {
                    // console.log('[CourseHome] Home loaded — no evaluation present for course', { courseId: courseId })
                }
            } catch (err) {
                console.warn('[CourseHome] error logging evaluation presence:', err)
            }

            const isCompleted =
                Array.isArray(effectiveCourse?.moduls) &&
                effectiveCourse.moduls.every(
                    (module) => module.status === LEARNING_STATUS.COMPLETED,
                )

            await set_label(isCompleted, effectiveCourse)
            // console.log('---------------- [DEBUG CourseHome] fetchDataNew effectiveCourse A SETEAR:', JSON.stringify(effectiveCourse, null, 2))
            setCurso(effectiveCourse)
            // Asegurar que el porcentaje venga del effectiveCourse ya normalizado
            try {
                let newAssessment = null
                if (effectiveCourse) {
                    // Preferir campo directo del curso
                    if (
                        typeof effectiveCourse.assessmentResult !== 'undefined' &&
                        effectiveCourse.assessmentResult !== null
                    ) {
                        newAssessment = effectiveCourse.assessmentResult
                    }

                    // Si hay evaluaciones, tomar la primera disponible
                    if (
                        (!newAssessment || newAssessment === null) &&
                        Array.isArray(effectiveCourse.evaluations) &&
                        effectiveCourse.evaluations.length > 0
                    ) {
                        const ev0 = effectiveCourse.evaluations[0]
                        newAssessment =
                            ev0?.assessmentResult ??
                            ev0?.score ??
                            ev0?.result ??
                            null
                    }
                }

                setPorcentanje_aprobacion(newAssessment)
                // console.log('[CourseHome] setPorcentanje_aprobacion ->', newAssessment)
            } catch (err) {
                console.warn(
                    '[CourseHome] error setting porcentanje_aprobacion',
                    err,
                )
                setPorcentanje_aprobacion(null)
            }
            setIsLoading(false)
            // console.log('[DEBUG CourseHome] fetchDataNew - final curso set:', JSON.stringify(effectiveCourse, null, 2))
            // console.log('[DEBUG WEB CourseHome] fetchDataNew - final curso set (WEB):', JSON.stringify(effectiveCourse, null, 2))
        } catch (error) {
            console.error('166 Error fetching course data:', error)
        } finally {
            setIsLoading(false)
        }
    }

    // Forzar refresco al volver al curso desde un módulo (sin recargar manualmente)
    // Usamos una callback estable y además verificamos si hubo un cambio de versión de progreso
    const lastProgressVersionRef = useRef(getProgressVersion())
    useFocusEffect(
        React.useCallback(() => {
            try {
                const currentVersion = getProgressVersion()
                if (currentVersion !== lastProgressVersionRef.current) {
                    lastProgressVersionRef.current = currentVersion
                    try {
                        setReloadCounter((c) => c + 1)
                    } catch {}
                }
            } catch {}
            fetchDataNew().then(() => {
                getTerms()
            })
        }, []),
    )

    // Suscribirse a actualizaciones de progreso (emitidas al completar módulos)
    useEffect(() => {
        const unsubscribe = subscribeProgressUpdate((version, payload) => {
            try {
                if (typeof version === 'number')
                    lastProgressVersionRef.current = version
            } catch {}

            // Si recibimos payload para este curso, actualizar optimistamente las etiquetas de los módulos
            try {
                if (
                    payload &&
                    payload.courseId &&
                    payload.courseId?.toString() === curso?._id?.toString()
                ) {
                    const updates = Array.isArray(payload.updated)
                        ? payload.updated
                        : []
                    if (updates.length > 0) {
                        setCurso((prev) => {
                            if (!prev || !Array.isArray(prev.moduls)) return prev
                            const mapStatusById = new Map()
                            for (const u of updates) {
                                if (u && u.moduleId)
                                    mapStatusById.set(String(u.moduleId), u.status)
                            }
                            const updatedModuls = prev.moduls.map((m) => {
                                const newStatus = mapStatusById.get(String(m._id))
                                return typeof newStatus !== 'undefined'
                                    ? { ...m, status: newStatus }
                                    : m
                            })
                            const nextCourse = { ...prev, moduls: updatedModuls }
                            try {
                                const isCompleted = updatedModuls.every(
                                    (module) =>
                                        module.status === LEARNING_STATUS.COMPLETED,
                                )
                                // Actualizar CTA en base al nuevo estado
                                set_label(isCompleted, nextCourse)
                            } catch {}
                            return nextCourse
                        })
                    }
                }
            } catch {}

            try {
                setReloadCounter((c) => c + 1)
            } catch {}
            // Hacer refetch para confirmar y traer assessmentResult/otros campos coherentes
            fetchDataNew().catch(() => {})
        })
        return () => {
            try {
                unsubscribe && unsubscribe()
            } catch {}
        }
    }, [curso?._id])

    // Reintentar traer TTCC al recuperar conectividad
    useEffect(() => {
        const unsubscribe = NetInfo.addEventListener((state) => {
            try {
                if (state.isConnected) {
                    getTerms()
                }
            } catch {}
        })
        return () => {
            try {
                unsubscribe && unsubscribe()
            } catch {}
        }
    }, [])

    const next_course = () => {
        if (!curso?._id) {
            console.error('❌ No course available for evaluation')
            return
        }

        setCurrentCourse_store(curso)

        // este es el bopton que te lleva desde el curso a lo pendiente
        // @Lau falta el next_content en caso de modulo desaprobado
        if (labelNextCourse === LABEL_STATE.label_course) {
            const module_index = modules.findIndex(
                (module) => module.status === LEARNING_STATUS.BLOCKED,
            )

            if (module_index !== -1) {
                const module_navigation = modules[module_index - 1]

                navigation.navigate('Module', {
                    item: module_navigation,
                    courseItem: curso,
                    labelNextCourse: labelNextCourse,
                })
            } else {
                const module_index = modules.findIndex(
                    (module) => module.status === LEARNING_STATUS.PENDIENTE,
                )

                if (module_index !== -1) {
                    const module_navigation = modules[module_index]

                    navigation.navigate('Module', {
                        item: module_navigation,
                        courseItem: curso,
                        labelNextCourse: labelNextCourse,
                    })
                } else {
                    console.log('NO ENCONTRE NINGUN MODULO PENDIENTE')
                }
            }
        }

        if (labelNextCourse === LABEL_STATE.label_evaluation) {
            // Evaluación de curso (incluye caso de retry REPROBADO):
            // 1) Aseguramos CourseHome de fondo
            try {
                navigation.navigate('Course', { item: curso, array_cursos: [] })
            } catch {}

            // Helper robusto para extraer el ID de evaluación
            const getFirstEvaluationId = (course) => {
                try {
                    let evals = course?.evaluations
                    if (typeof evals === 'string') {
                        try {
                            evals = JSON.parse(evals)
                        } catch {}
                    }
                    if (Array.isArray(evals) && evals.length > 0) {
                        const e0 = evals[0]
                        if (typeof e0 === 'string') return e0
                        if (e0 && (e0._id || e0.id)) return String(e0._id || e0.id)
                    }
                    // Fallbacks comunes
                    const single = course?.evaluation || course?.evaluation_id
                    if (typeof single === 'string') return single
                    if (single && (single._id || single.id))
                        return String(single._id || single.id)
                    return null
                } catch {
                    return null
                }
            }

            const firstEvalId = getFirstEvaluationId(curso)

            // Validar límite de reintentos antes de entrar
            const firstEvalObj = (() => {
                try {
                    let evals = curso?.evaluations
                    if (typeof evals === 'string') evals = JSON.parse(evals)
                    if (Array.isArray(evals) && evals.length > 0) {
                        const e0 = evals[0]
                        if (e0 && typeof e0 === 'object' && (e0._id || e0.id)) return e0
                    }
                } catch {}
                return null
            })()

            if (firstEvalObj) {
                const maxRetry = firstEvalObj.max_retry_attempts != null
                    ? parseInt(firstEvalObj.max_retry_attempts)
                    : null
                const attemptsCount = parseInt(firstEvalObj.attempts_count) || 0
                const canRepeat = !!firstEvalObj.can_repeat

                if (canRepeat && maxRetry !== null && maxRetry > 0 && attemptsCount >= maxRetry) {
                    openBottomSheet(
                        <BottomSheetAlert
                            closeBottomSheet={closeBottomSheet}
                            title="Límite de intentos alcanzado"
                            desc={`Usaste todos tus intentos (${attemptsCount} de ${maxRetry}). No puedes reintentar esta evaluación.`}
                            button="Aceptar"
                        />,
                    )
                    return
                }
            }

            // 2) Abrimos Survey encima SOLO si tenemos evaluationId válido
            if (firstEvalId) {
                console.log(
                    '[DEBUG WEB CourseHome] abrir Survey con evaluationId:',
                    firstEvalId,
                )
                console.log(
                    '[DEBUG WEB CourseHome] Navegando a Survey desde updatear_status',
                )
                setTimeout(() => {
                    try {
                        console.log(
                            '[DEBUG WEB CourseHome] Ejecutando navigation.navigate a Survey',
                        )
                        navigation.navigate('Survey', {
                            evaluation: [firstEvalId],
                            next_content: null,
                            current_modul: {},
                            option: OPTIONS.OPTION_COURSE,
                            course_id: String(curso?._id || ''),
                            courseItem: curso,
                        })
                        console.log(
                            '[DEBUG WEB CourseHome] navigation.navigate ejecutado exitosamente',
                        )
                    } catch (error) {
                        console.error(
                            '[DEBUG WEB CourseHome] Error en navigation.navigate:',
                            error,
                        )
                    }
                }, 0)
            } else {
                console.warn(
                    '[CourseHome] No se encontró evaluationId para el curso, evitando abrir Survey',
                )
            }
        }

        if (
            labelNextCourse === LABEL_STATE.label_course_complete ||
            labelNextCourse === LABEL_STATE.label_course_pending
        ) {
            try {
                if (navigation.canGoBack && navigation.canGoBack()) {
                    navigation.goBack()
                } else {
                    navigation.reset?.({
                        index: 0,
                        routes: [{ name: 'LearningHome' }],
                    })
                }
            } catch (e) {
                try {
                    navigation.navigate('LearningHome')
                } catch {}
            }
        }
    }

    const goBack = () => {
        try {
            if (navigation.canGoBack && navigation.canGoBack()) {
                navigation.goBack()
            } else {
                navigation.reset?.({ index: 0, routes: [{ name: 'LearningHome' }] })
            }
        } catch (e) {
            try {
                navigation.navigate('LearningHome')
            } catch {}
        }
    }

    useEffect(() => {
        const unsubscribe = navigation.addListener('focus', () => {
            setReloadCounter((prevCounter) => prevCounter + 1)
        })
        try {
            if (curso?._id)
                TrackingServices.addTracking(
                    curso._id,
                    'get_course',
                    'learning_courses',
                )
        } catch {}

        return unsubscribe
    }, [navigation])

    const [isExpanded, setIsExpanded] = useState(false)
    const [showReadMore, setShowReadMore] = useState(false)

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded)
    }

    const onPressCertificate = (url) => {
        // const webViewUrl = isAndroid() ? `https://drive.google.com/viewerng/viewer?embedded=true&url=${url}` : url

        if (Platform.OS === 'web') {
            try {
                window.open(url, '_blank')
                return
            } catch (error) {
                console.error(
                    '[onPressCertificate] Error opening PDF in new tab:',
                    error,
                )
                const link = document.createElement('a')
                link.href = url
                link.download = 'certificate.pdf'
                link.click()
                return
            }
        }

        navigation.navigate('WebView', { link: url })
    }

    //Verificar si la descripción tiene más de 140 caracteres
    React.useEffect(() => {
        if (curso?.description_long && curso?.description_long.length > 140) {
            setShowReadMore(true)
        } else {
            setShowReadMore(false)
        }
    }, [curso?.description_long])

    const [showDownloadButton, setShowDownloadButton] = useState(false)
    const versionName =
        LEARNING_STORE_NAMES.COURSES_ZIP_VERSION + String(curso?._id || '')
    const pendingAsset = require('../../../assets/cloudCheck.png')
    const downloadedAsset = require('../../../assets/cloudCheck.png')
    const [contentDownloaded, setContentDownloaded] = useState(false)
    const [loading, setLoading] = useState(false)

    let path = `courses/${String(curso?._id || '')}`

    const downloadCourse = async () => {
        const netInfoState = await NetInfo.fetch()

        if (!netInfoState.isConnected) {
            console.error('No hay conexión a internet, no podes descargar el curso')
            return
        }

        setLoading(true)
        await setKeepAwake('active')

        let image = require('../../../assets/circleLoader.gif')
        let title = languageFile.course_download_in_process
        let description = languageFile.course_is_downloading

        openBottomSheet(
            <ModalDownloadCourse
                image={image}
                title={title}
                description={description}
                button={false}
                buttonDelete={false}
                buttonCancel={false}
                closeBottomSheet={closeBottomSheet}
            />,
            undefined,
            false,
            false,
            false,
        )

        try {
            // let url = 'https://resources-one.s3.us-east-2.amazonaws.com/test/6399edb50c0cda0008b922b6_0_json_21184_11-11-2024-15-53.zip'
            let url = cleanDoubleQuotedString(curso.download_zip)
            console.log('URL del zip a descargar:', url)
            let name = `courses/${String(curso?._id || '')}`
            let path = await downloadAndUnzipAllFiles(name, url)

            if (!path) {
                console.error('Hubo un error al descargar el curso')
                console.log('Intento descargar todos los modulos...')
                // si tira error intento descargar todos los modulos..
                const allModulesDownload = await downloadAllModules()
                console.log(
                    '513 --- 🚀 ~ downloadCourse ~ allModulesDownload:',
                    allModulesDownload,
                )

                if (!allModulesDownload) {
                    console.error('Hubo un error al descargar todos los modulos')
                    setShowDownloadButton(true)
                    setContentDownloaded(false)
                    closeBottomSheet(true)
                    return
                }
            }

            let image = require('../../../assets/downloadCourse.png')
            let title = languageFile.downloaded_course
            let description = languageFile.you_can_train_offline

            openBottomSheet(
                <ModalDownloadCourse
                    image={image}
                    title={title}
                    description={description}
                    button={true}
                    buttonDelete={false}
                    buttonCancel={false}
                    closeBottomSheet={closeBottomSheet}
                />,
            )
            let zipVersion = getVersionLearningByURL(url)

            console.log('zipVersion', zipVersion)

            if (zipVersion || zipVersion === 0) {
                await UserServices.updateGlobalVersion(versionName, zipVersion)
                setShowDownloadButton(false)
                setContentDownloaded(true)
                setReloadFlag((prevflag) => !prevflag)
                setReloadCounter((prevCounter) => prevCounter + 1)
            }
        } catch (error) {
            console.error('Error downloading course:', error)
            setContentDownloaded(false)
            closeBottomSheet(true)
        } finally {
            await setKeepAwake('desactive')
            setLoading(false)
        }
    }

    const [courseDeleted, setCourseDeleted] = useState(false)
    const [reloadFlag, setReloadFlag] = useState(false)

    const deleteCourse = async () => {
        let image = require('../../../assets/deleteCourse.png')
        let title = languageFile.delete_offline_course
        let description = languageFile.not_view_course_offline

        openBottomSheet(
            <ModalDownloadCourse
                image={image}
                title={title}
                description={description}
                button={false}
                buttonDelete={true}
                buttonCancel={true}
                closeBottomSheet={closeBottomSheet}
                courseDeleted={() => deletedCourse()}
            />,
        )
    }
    const deletedCourse = async () => {
        setLoading(true)

        try {
            await UserServices.updateGlobalVersion(versionName, null)
            const pathToDelete = `${documentDirectory}unzipped/${path}`
            await deletePathFile(pathToDelete)

            let image = require('../../../assets/deletedCourse.png')
            let title = languageFile.course_is_not_available
            let description = languageFile.not_available_offline

            openBottomSheet(
                <ModalDownloadCourse
                    image={image}
                    title={title}
                    description={description}
                    button={true}
                    buttonDelete={false}
                    buttonCancel={false}
                    closeBottomSheet={closeBottomSheet}
                    courseDeleted={courseDeleted}
                />,
            )
            setShowDownloadButton(true)
            setContentDownloaded(false)
            setReloadFlag((prevflag) => !prevflag)
            setReloadCounter((prevCounter) => prevCounter + 1)
        } catch (error) {
            console.error('Error deleting course:', error)
        } finally {
            setLoading(false)
        }
    }

    const getAllMediasModules = (modules) => {
        return modules.flatMap((module) => {
            let url = module.media_slides
            return url.flatMap((item) => item.media)
        })
    }

    const downloadAllModules = async () => {
        try {
            const contentsUrlDownloads = getAllMediasModules(modules)
            let downloadedContent = await downloadContent(path, contentsUrlDownloads)
            if (!downloadedContent) {
                console.error('Hubo un error al descargar todos los modulos')
                return
            }
            console.log('Todos los modulos descargados correctamente')
            return downloadedContent
        } catch (error) {
            console.error('Error downloadAllModules:', error)
        }
    }

    const { connectedStable } = getConection()
    const checkValidateDownloadConnection = async () => {
        try {
            // Usar estado estable global para evitar falsos positivos
            if (!connectedStable && !showDownloadButton) {
                setAlert(
                    'No tienes conexión',
                    'white',
                    'wifi-off',
                    'rgba(229, 29, 13, 0.8)',
                    true,
                )
            }
        } catch (error) {
            console.error('Error validating:', error)
        }
    }

    // useEffect(() => {

    //   console.log('--------------------modules changed--------------------:', modules);

    // }, [modules])

    // console.log('download zip: ', curso.download_zip)

    useEffect(() => {
        // Esperar a tener curso y un download_zip válido
        if (!hasValue(curso?.download_zip)) {
            return
        }

        const validateDownload = async () => {
            try {
                // Recupera la version del zip ya descargado
                const oldVersion = await UserServices.getGlobalVersion(versionName)
                // Consigo la nueva version del zip
                const download_url = cleanDoubleQuotedString(curso.download_zip)
                const newVersion = getVersionLearningByURL(download_url)
                // const newVersion = getVersionLearningByURL(curso.download_zip)
                // let url = 'https://resources-one.s3.us-east-2.amazonaws.com/test/6399edb50c0cda0008b922b6_0_json_21184_11-11-2024-15-53.zip'
                // const newVersion = getVersionByURL(url)
                console.log('Versiones, ', oldVersion + ' // => ' + newVersion)
                // Si no hay version descargada, mostrar botón de descarga
                if (!oldVersion && oldVersion !== 0) {
                    return setShowDownloadButton(true)
                }
                console.log('compara versiones ', oldVersion, newVersion)

                //Comparar versiones
                if (oldVersion == newVersion) {
                    setShowDownloadButton(false)
                    setContentDownloaded(true)
                    return console.log('No hay cambios en la versión')
                }

                // Eliminar directorio anterior
                const unzippPath = `${documentDirectory}unzipped/courses/${String(curso?._id || '')}`
                await verifyAndDeleteZip(unzippPath)

                //Si las versiones no coinciden, descargar
                await downloadCourse()
            } catch (error) {
                console.error('Error validating:', error)
                setShowDownloadButton(true)
                setContentDownloaded(false)
            }
        }

        validateDownload()

        checkValidateDownloadConnection()

        return () => {
            closeAlert()
        }
    }, [curso?.download_zip])
    const breakPoint = useBreakpoint()
    const isMobile = breakPoint === 'sm'

    const { width: winWidth } = useWindowDimensions()
    const expoConfig = Constants.expoConfig || { slug: '' }
    const reprobatedButtonText =
        expoConfig.slug != 'branca-one' ? 'Revisar' : 'Rehacer'
    const courseMaxSize = 1032

    return isLoading ? (
        <Loader />
    ) : (
        <View
            style={{ flex: 1, width: '100%', height: '100%', flexDirection: 'row' }}
        >
            <View
                style={[
                    styles.containerModule,
                    !isMobile && { maxWidth: courseMaxSize },
                ]}
            >
                <ScrollView
                    style={[
                        styles.container,
                        !isMobile && { maxWidth: courseMaxSize },
                    ]}
                    key={curso?._id || 'course'}
                    showsVerticalScrollIndicator={false}
                >
                    <View>
                        <View style={styles.blockHeader}>
                            <View>
                                <CachedImage
                                    styles={[
                                        styles.imageHeader,
                                        !isMobile && {
                                            width: 280,
                                            marginRight: 20,
                                            borderRadius: 16,
                                        },
                                    ]}
                                    uri={
                                        curso?.cover_image
                                            ? curso.cover_image
                                            : placeholderLearning
                                    }
                                    path={path}
                                    useBackground={true}
                                />
                            </View>

                            <View
                                style={{
                                    flex: 1,
                                    paddingRight: 10,
                                }}
                            >
                                {!!curso?.title && (
                                    <Text
                                        style={[
                                            styles.courseName,
                                            !isMobile && { fontSize: 36 },
                                        ]}
                                    >
                                        {String(curso?.title)}
                                    </Text>
                                )}
                                {!isMobile && (
                                    <>
                                        {Boolean(curso?.description_long) &&
                                            curso?.description_long?.length > 0 && (
                                                <RenderHTML
                                                    source={{
                                                        html: String(
                                                            curso?.description_long ||
                                                                '',
                                                        ),
                                                    }}
                                                    baseStyle={
                                                        styles.courseDescriptionBig
                                                    }
                                                    contentWidth={winWidth}
                                                />
                                            )}
                                    </>
                                )}
                                {isMobile && <View style={{ height: 4 }} />}
                                <View
                                    style={{
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                    }}
                                >
                                    {isWeb &&
                                        curso?.status != 1 &&
                                        labelNextCourse ===
                                            LABEL_STATE.label_course_complete &&
                                        porcentanje_aprobacion !== null && (
                                            <AlertAssesment
                                                onPress={next_course}
                                                label={labelNextCourse}
                                                porcentanje_aprobacion={
                                                    porcentanje_aprobacion ?? ''
                                                }
                                                curso={curso}
                                                onPressCertificate={(url) =>
                                                    onPressCertificate(url)
                                                }
                                                isWeb={isWeb}
                                            />
                                        )}

                                    {loading ? (
                                        <View
                                            style={{
                                                width: 32,
                                                height: 32,
                                                marginLeft: 4,
                                            }}
                                        >
                                            <Loader />
                                        </View>
                                    ) : (
                                        <>
                                            {showDownloadButton && (
                                                <TouchableOpacity
                                                    onPress={() => downloadCourse()}
                                                    style={[
                                                        styles.containerOffline,
                                                        !isMobile && {
                                                            height: 44,
                                                            marginEnd: 16,
                                                            marginTop: 0,
                                                            paddingHorizontal: 32,
                                                        },
                                                    ]}
                                                >
                                                    <Text
                                                        style={{
                                                            fontSize: 16,
                                                            fontWeight: !isMobile
                                                                ? 'bold'
                                                                : 'normal',
                                                            color: theme.colors
                                                                .textSecondary,
                                                        }}
                                                    >
                                                        {
                                                            languageFile.download_offline
                                                        }
                                                    </Text>
                                                    <View style={{ width: 8 }} />
                                                    <Feather
                                                        name='download'
                                                        size={16}
                                                        color={
                                                            theme.colors
                                                                .textSecondary
                                                        }
                                                    />
                                                </TouchableOpacity>
                                            )}

                                            {contentDownloaded && (
                                                <TouchableOpacity
                                                    onPress={() => deleteCourse()}
                                                    style={[
                                                        styles.containerOffline,
                                                        !isMobile && {
                                                            height: 44,
                                                            marginEnd: 16,
                                                            marginTop: 0,
                                                            paddingHorizontal: 32,
                                                        },
                                                    ]}
                                                >
                                                    <Text
                                                        style={{
                                                            fontSize: 16,
                                                            fontWeight: !isMobile
                                                                ? 'bold'
                                                                : 'normal',
                                                            color: theme.colors
                                                                .colorApproved,
                                                        }}
                                                    >
                                                        {
                                                            languageFile.available_offline
                                                        }
                                                    </Text>
                                                    <View style={{ width: 8 }} />
                                                    <Image
                                                        style={{
                                                            width: 16,
                                                            height: 16,
                                                        }}
                                                        tintColor={
                                                            theme.colors
                                                                .colorApproved
                                                        }
                                                        source={pendingAsset}
                                                    />
                                                </TouchableOpacity>
                                            )}
                                        </>
                                    )}

                                    {!isMobile &&
                                        (labelNextCourse !=
                                            LABEL_STATE.label_course_complete ||
                                            labelNextCourse ===
                                                LABEL_STATE.label_evaluation) && (
                                            <>
                                                <TouchableOpacity
                                                    style={[
                                                        {
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            borderColor:
                                                                theme.colors
                                                                    .colorPrimary,
                                                            backgroundColor: 'white',
                                                            borderWidth: 1.0,
                                                            borderRadius: 10,
                                                            paddingVertical: 4,
                                                            paddingHorizontal: 32,
                                                        },
                                                        curso?.status == -1
                                                            ? {
                                                                  borderColor:
                                                                      theme.colors
                                                                          .colorRetry,
                                                              }
                                                            : {},
                                                        !isMobile && {
                                                            height: 44,
                                                        },
                                                    ]}
                                                    activeOpacity={0.7}
                                                    onPress={next_course}
                                                >
                                                    <Text
                                                        style={{
                                                            fontSize: 18,
                                                            fontWeight: 'bold',
                                                            color:
                                                                curso?.status == -1
                                                                    ? theme.colors
                                                                          .colorRetry
                                                                    : theme.colors
                                                                          .colorPrimary,
                                                            marginEnd: 12,
                                                            includeFontPadding: false,
                                                        }}
                                                    >
                                                        {curso?.status == -1
                                                            ? reprobatedButtonText
                                                            : translateLabel(
                                                                  labelNextCourse,
                                                                  languageFile,
                                                              )}
                                                    </Text>

                                                    {translateLabel(
                                                        labelNextCourse,
                                                        languageFile,
                                                    ) ===
                                                    languageFile.continue_course ? (
                                                        <Feather
                                                            name='chevron-right'
                                                            size={18}
                                                            color={
                                                                theme.colors
                                                                    .colorPrimary
                                                            }
                                                        />
                                                    ) : (
                                                        <>
                                                            {curso?.status == -1 ? (
                                                                <Ionicons
                                                                    name='reload-outline'
                                                                    size={18}
                                                                    color={
                                                                        theme.colors
                                                                            .colorRetry
                                                                    }
                                                                />
                                                            ) : (
                                                                <SimpleLineIcons
                                                                    name={
                                                                        curso?.status ==
                                                                        -1
                                                                            ? 'reload'
                                                                            : translateLabel(
                                                                                    labelNextCourse,
                                                                                    languageFile,
                                                                                ) ===
                                                                                languageFile.evaluate_me
                                                                              ? 'graduation'
                                                                              : 'arrow-right'
                                                                    }
                                                                    size={18}
                                                                    color={
                                                                        curso?.status ==
                                                                        -1
                                                                            ? theme
                                                                                  .colors
                                                                                  .colorRetry
                                                                            : theme
                                                                                  .colors
                                                                                  .colorPrimary
                                                                    }
                                                                />
                                                            )}
                                                        </>
                                                    )}
                                                </TouchableOpacity>
                                            </>
                                        )}
                                </View>
                            </View>
                        </View>

                        {isMobile && (
                            <>
                                {Boolean(curso?.description_long) &&
                                    curso?.description_long?.length > 140 && (
                                        <RenderHTML
                                            source={{
                                                html: isExpanded
                                                    ? String(
                                                          curso?.description_long ||
                                                              '',
                                                      )
                                                    : `${String(curso?.description_long || '').slice(0, 140)}...`,
                                            }}
                                            baseStyle={styles.courseDescription}
                                            contentWidth={winWidth}
                                        />
                                    )}
                                {Boolean(curso?.description_long) &&
                                    curso?.description_long?.length <= 140 && (
                                        <RenderHTML
                                            source={{
                                                html: String(
                                                    curso?.description_long || '',
                                                ),
                                            }}
                                            baseStyle={styles.courseDescription}
                                            contentWidth={winWidth}
                                        />
                                    )}
                                {showReadMore && (
                                    <TouchableOpacity onPress={toggleExpanded}>
                                        <Text style={styles.seeMoreText}>
                                            {isExpanded
                                                ? languageFile.see_less
                                                : languageFile.see_more}
                                        </Text>
                                    </TouchableOpacity>
                                )}

                                {labelNextCourse !=
                                    LABEL_STATE.label_course_complete && (
                                    <View style={styles.containerButtonLine}>
                                        <TouchableOpacity
                                            style={[
                                                styles.buttonLine,
                                                curso?.status == -1
                                                    ? {
                                                          backgroundColor:
                                                              theme.colors
                                                                  .colorRetry,
                                                      }
                                                    : {},
                                                !isMobile && { height: 50 },
                                            ]}
                                            activeOpacity={0.7}
                                            onPress={next_course}
                                        >
                                            <Text
                                                style={[
                                                    styles.textButtonLine,
                                                    !isMobile && { fontSize: 16 },
                                                ]}
                                            >
                                                {curso?.status == -1
                                                    ? reprobatedButtonText
                                                    : translateLabel(
                                                          labelNextCourse,
                                                          languageFile,
                                                      )}
                                            </Text>

                                            <SimpleLineIcons
                                                name={
                                                    translateLabel(
                                                        labelNextCourse,
                                                        languageFile,
                                                    ) ===
                                                    languageFile.continue_course
                                                        ? 'arrow-right'
                                                        : curso?.status == -1
                                                          ? 'reload'
                                                          : translateLabel(
                                                                  labelNextCourse,
                                                                  languageFile,
                                                              ) ===
                                                              languageFile.evaluate_me
                                                            ? 'graduation'
                                                            : 'arrow-right'
                                                }
                                                size={
                                                    labelNextCourse ===
                                                    languageFile.continue_course
                                                        ? isMobile
                                                            ? 12
                                                            : 16
                                                        : isMobile
                                                          ? 18
                                                          : 22
                                                }
                                                color={colorIcon}
                                                style={styles.marginLeft}
                                            />
                                        </TouchableOpacity>
                                    </View>
                                )}
                            </>
                        )}
                    </View>

                    {!isMobile && (
                        <Text
                            style={{
                                fontSize: 24,
                                fontWeight: 'bold',
                                marginTop: 16,
                                paddingTop: 16,
                                borderTopColor: theme.colors.lightGray,
                                borderTopWidth: 1,
                                marginBottom: 10,
                                marginHorizontal: 12,
                            }}
                        >
                            Contenidos
                        </Text>
                    )}
                    <FlatList
                        data={modules}
                        style={{ flexGrow: 0 }}
                        keyExtractor={(item) => item._id}
                        horizontal={false}
                        nestedScrollEnabled={true}
                        showsHorizontalScrollIndicator={false}
                        estimatedItemSize={200}
                        extraData={reloadCounter}
                        ItemSeparatorComponent={() => (
                            <View style={{ marginVertical: 0 }} />
                        )}
                        renderItem={({ item: moduleItem, index }) => (
                            <ModulesItem
                                item={moduleItem}
                                courseItem={curso}
                                labelNextCourse={labelNextCourse}
                                path={path}
                                reloadFlag={reloadFlag}
                                isMobile={isMobile}
                            />
                        )}
                    />

                    <View style={styles.spacer2}></View>
                </ScrollView>

                {!isWeb &&
                    curso?.status != 1 &&
                    (labelNextCourse === LABEL_STATE.label_course_complete ||
                        labelNextCourse === LABEL_STATE.label_evaluation ||
                        labelNextCourse === LABEL_STATE.label_course_pending ||
                        porcentanje_aprobacion !== null) && (
                        <AlertAssesment
                            onPress={next_course}
                            label={labelNextCourse}
                            porcentanje_aprobacion={porcentanje_aprobacion ?? ''}
                            curso={curso}
                            onPressCertificate={(url) => onPressCertificate(url)}
                        />
                    )}

                {/* {isMobile &&
                    labelNextCourse == LABEL_STATE.label_course &&
                    curso?.status != 3 && (
                        <ProgressCourse progress={progress_percentage} />
                    )} */}
                {/*{curso.status == LEARNING_STATUS.COMPLETED && curso.evaluations == null && (
                <AlertCompleteNoEvaluation onPress={goBack} label={LABElS.GO_BACK_COURSE} />
            )}*/}
            </View>
            {/* Comentado hasta que se implemente widget con siguientes cursos */}
            {/* <View style={{ height: '100%', width: 1, backgroundColor: theme.colors.lightGray, marginStart: 20 }} /> */}
        </View>
    )
}

const ProgressCourse = ({ progress }) => {
    const roundedProgress = Math.round(progress)
    const { languageFile } = getLanguage()

    return (
        <>
            <Progress.Bar
                progress={progress / 100}
                height={5}
                width={width}
                style={styles.progressBar}
                color={theme.colors.colorApproved}
                unfilledColor={theme.colors.lightGray}
            />
        </>
    )
}

const ModulesItem = ({ item, courseItem, labelNextCourse, path, isMobile }) => {
    const navigation = useNavigation()
    const [contentDownloaded, setContentDownloaded] = useState(false)
    const [showDownloadButton, setShowDownloadButton] = useState(false)
    const { width: winWidth } = useWindowDimensions()

    const STATUS = item.status
    const porcentanje_aprobacion = item.assessmentResult

    const { languageFile } = getLanguage()

    const set_status_label = () => {
        let label_text = ''

        switch (STATUS) {
            case LEARNING_STATUS.BLOCKED:
                label_text = languageFile.locked
                // DISABLED = true
                break
            case LEARNING_STATUS.PENDIENTE:
                label_text = languageFile.pending
                break
            case LEARNING_STATUS.VIEWED:
                label_text = languageFile.seen
                break
            case LEARNING_STATUS.COMPLETED:
                label_text = languageFile.complete
                break
            case LEARNING_STATUS.REPROBADO:
                label_text = getReprobatedText()

                break
            case LEARNING_STATUS.PENDING_CONNECTION:
                label_text = languageFile.sync_pend
                break
            case LEARNING_STATUS.IN_PROGRESS:
                label_text = languageFile.in_progress
                break
            default:
                label_text = languageFile.pending
                break
        }

        return label_text.toUpperCase()
    }
    const isContentBlocked = item?.status === LEARNING_STATUS.BLOCKED

    useEffect(() => {
        const checkContentDownloaded = async () => {
            if (!item) {
                return
            }
            let url = item.media_slides

            // Verificar que media_slides exista y sea un array antes de usar flatMap
            if (!url || !Array.isArray(url) || url.length === 0) {
                console.log(
                    '[checkContentDownloaded] No media_slides found or invalid format',
                )
                setContentDownloaded(true)
                setShowDownloadButton(false)
                return
            }

            let contents = url.flatMap((item) => {
                return item.media || []
            })

            if (contents.length > 0) {
                if (Platform.OS === 'web') {
                    setContentDownloaded(false)
                    return
                }
                const ImageName = getNameUrl(contents[0])
                const exist = await searchFilebyName(ImageName, 'unzipped/' + path)
                if (!exist) {
                    setContentDownloaded(false)
                    setShowDownloadButton(true)
                    return
                }
                setContentDownloaded(true)
                setShowDownloadButton(false)
            } else {
                setContentDownloaded(true)
                setShowDownloadButton(false)
            }
        }
        checkContentDownloaded()
    }, [item])

    return (
        <View>
            <View style={styles.container}>
                <TouchableOpacity
                    style={[
                        styles.blockList,
                        STATUS === LEARNING_STATUS.BLOCKED && styles.block_content,
                    ]}
                    onPress={() =>
                        navigation.navigate('Module', {
                            item: item,
                            courseItem: courseItem,
                            labelNextCourse: labelNextCourse,
                        })
                    }
                    disabled={STATUS === LEARNING_STATUS.BLOCKED ? true : false}
                    activeOpacity={0.7}
                >
                    <View>
                        <CachedImage
                            styles={[
                                styles.imageModuleList,
                                !isMobile && {
                                    width: 96,
                                    height: 96,
                                    marginRight: 16,
                                },
                            ]}
                            uri={item.cover_image}
                            path={path}
                            useBackground={true}
                        />
                    </View>

                    <View style={styles.containerModuleList}>
                        <View style={styles.containerTitleModuleList}>
                            <Text
                                style={[
                                    styles.titleModuleList,
                                    !isMobile && { fontSize: 16 },
                                ]}
                                numberOfLines={3}
                            >
                                {item.title}
                            </Text>
                        </View>

                        {item.description_short && (
                            <>
                                {isMobile ? (
                                    <RenderHTML
                                        source={{ html: item.description_short }}
                                        baseStyle={styles.descriptionModuleList}
                                        contentWidth={winWidth}
                                    />
                                ) : (
                                    <RenderHTML
                                        source={{ html: item.description_short }}
                                        baseStyle={{
                                            fontSize: 16,
                                            color: theme.colors.textSecondary,
                                            fontWeight: 'normal',
                                            marginBottom: 10,
                                            paddingRight: 10,
                                        }}
                                        contentWidth={winWidth}
                                    />
                                )}
                            </>
                        )}
                        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                            <View style={styles.containerStatusModuleList}>
                                <View
                                    style={[
                                        styles.statusModuleList,
                                        {
                                            backgroundColor:
                                                STATUS != LEARNING_STATUS.BLOCKED
                                                    ? statusColors[STATUS]
                                                    : 'transparent' ||
                                                      theme.colors.colorLocked,
                                            borderColor:
                                                STATUS === LEARNING_STATUS.BLOCKED
                                                    ? theme.colors.colorLocked
                                                    : 'transparent',
                                        },
                                        // {
                                        //     backgroundColor:
                                        //         set_status_label() === 'BLOQUEADO'
                                        //             ? theme.colors.colorLocked
                                        //             : set_status_label() === 'PENDIENTE'
                                        //             ? theme.colors.colorPending
                                        //             : set_status_label() === 'VISTO'
                                        //             ? theme.colors.colorSeen
                                        //             : set_status_label() === 'COMPLETO'
                                        //             ? theme.colors.colorApproved
                                        //             : set_status_label() === 'REPROBADO'
                                        //             ? theme.colors.colorRetry
                                        //             : theme.colors.colorPending,
                                        // },
                                    ]}
                                >
                                    <Text
                                        style={[
                                            styles.statusModuleText,
                                            {
                                                color:
                                                    STATUS ===
                                                    LEARNING_STATUS.BLOCKED
                                                        ? theme.colors.colorLocked
                                                        : 'white',
                                            },
                                            !isMobile && { fontSize: 14 },
                                        ]}
                                        numberOfLines={3}
                                    >
                                        {set_status_label()}
                                    </Text>
                                </View>
                                {/*<Image style={styles.imageTypeModuleList} source={contentTypesRoutes[item.content_type]} />*/}
                            </View>

                            {/*contentDownloaded && (
                                <View style={{ flexDirection: 'row', alignItems: 'center', marginHorizontal: 8 }}>
                                    <Text style={{ fontSize: 13, fontWeight: 'bold', color: theme.colors.textSecondary }}>Disponible offline</Text>
                                    <Image
                                        style={{ width: 20, height: 20, marginLeft: 4 }}
                                        tintColor={theme.colors.textSecondary}
                                        source={require('../../../assets/cloudCheck.png')}
                                    />
                                </View>
                            )*/}

                            {porcentanje_aprobacion && (
                                <View style={styles.marginStart}>
                                    <Text
                                        style={[
                                            styles.percentageModuleText,
                                            {
                                                color:
                                                    set_status_label() ===
                                                    languageFile.complete.toUpperCase()
                                                        ? theme.colors.colorApproved
                                                        : set_status_label() ===
                                                            languageFile.reprobate.toUpperCase()
                                                          ? theme.colors.colorRetry
                                                          : theme.colors.colorPending
                                                            ? theme.colors.colorRetry
                                                            : theme.colors
                                                                  .colorPending,
                                            },
                                        ]}
                                    >
                                        {Number(porcentanje_aprobacion) ===
                                        parseInt(Number(porcentanje_aprobacion))
                                            ? Number(porcentanje_aprobacion).toFixed(
                                                  0,
                                              )
                                            : Number(porcentanje_aprobacion).toFixed(
                                                  1,
                                              )}
                                        %
                                    </Text>
                                </View>
                            )}
                        </View>
                    </View>

                    <View style={[!isMobile && { alignSelf: 'center' }]}>
                        {isContentBlocked ? (
                            <EvilIcons
                                name='lock'
                                size={28}
                                color={theme.colors.colorLocked}
                            />
                        ) : (
                            <Feather
                                name='chevron-right'
                                size={20}
                                color={theme.colors.colorPending}
                            />
                        )}
                    </View>
                </TouchableOpacity>
            </View>
        </View>
    )
}

export const Module = ({ route }) => {
    const { courseItem, item, labelNextCourse } = route.params

    const currentModuleContext_store = useLearningStore(
        (state) => state.currentModuleContext,
    )
    const setCurrentModuleContext_store = useLearningStore(
        (state) => state.setCurrentModuleContext,
    )
    const currentCourse_store = useLearningStore((state) => state.currentCourse)
    const setCurrentCourse_store = useLearningStore(
        (state) => state.setCurrentCourse,
    )
    const navBarHeight = useAndroidNavBarHeight()
    // console.log("🚀 ~ Module ~ item:", item.media_slides)
    const { deviceId } = useDeviceStore()
    const { languageFile } = getLanguage()
    const navigation = useNavigation()
    const [isLastPage, setIsLastPage] = useState(false)
    const [showMedia, setShowMedia] = useState(true)
    const [nextModuleIndex, setNextModuleIndex] = useState(-1)
    const [nextModulData, setNextModulData] = useState({
        _id: item._id,
        content_type: item.content_type,
        course_name: item.course_name,
        description_long: item.description_long || '',
        description_short: item.description_short,
        likes: item.likes,
        link_share: item.link_share,
        media: item.media,
        media_slides: item.media_slides,
        status_liked: item.status_liked,
        title: item.title,
        users_comments: item.users_comments,
        cover_image: item.cover_image,
    })
    const [ultimate_module, setUltimate_module] = useState(false)
    const [lastContentSeen, setLastContentSeen] = useState(false)
    const { width: winWidth } = useWindowDimensions()
    // Evita duplicar el cierre/completado cuando el usuario sale sin tocar "Next"
    const completionTriggeredRef = useRef(false)

    //const token = useSelector((state) => state.auth.authToken)
    // console.log("🚀 ~ file: CourseHome.jsx:329 ~ Module ~ token:", token)
    const { updateStatusModule, find_current_module, find_next_module } =
        useFunctions()

    useEffect(() => {
        setCurrentModuleContext_store(courseItem)

        return () => {}
    }, [])

    useEffect(() => {
        TrackingServices.addTracking(item._id, 'get_module', 'learning_contents')
        const modulos = courseItem?.moduls
        const moduleIndex = modulos?.findIndex(
            (module) => module._id.toString() === item._id.toString(),
        )

        if (moduleIndex !== -1 && moduleIndex + 1 < modulos.length) {
            setNextModuleIndex(moduleIndex + 1)
            handleNextModule(moduleIndex + 1)
        } else {
            console.log('El módulo encontrado es el último en el array.')
            if (lastContentSeen) {
                updatear_status()
            }
            //setIsLastPage(true)
            setUltimate_module(true)
        }
        // }
    }, [courseItem, item, lastContentSeen])

    // ✅ NUEVO: Resetear flag al cambiar de módulo
    useEffect(() => {
        console.log(
            '🍏🍏🍏🍏🍏🍏 [Module] Mounted/Changed - Reset completion flag for:',
            item._id,
        )
        completionTriggeredRef.current = false
        setLastContentSeen(false)

        return () => {
            console.log('[Module] Unmounting - Reset completion flag')
            completionTriggeredRef.current = false
        }
    }, [item._id]) // Resetear cuando cambia el módulo

    // Disparador único para completar/desbloquear cuando el usuario llegó al final
    const triggerCompletionIfNeeded = async () => {
        try {
            console.log(
                'completionTriggeredRef.current => ',
                completionTriggeredRef.current,
            )
            console.log('lastContentSeen => ', lastContentSeen)
            if (completionTriggeredRef.current) {
                console.log('[Module] Completion already triggered, skipping')
                return
            }

            if (!lastContentSeen) {
                console.log('[Module] Last content not seen yet, skipping')
                return
            }

            completionTriggeredRef.current = true
            console.log('[CourseHome] Trigger completion on end/back')
            await updatear_status()
        } catch (e) {
            console.error('[CourseHome] triggerCompletionIfNeeded error:', e) // TODO: ERROR
            completionTriggeredRef.current = false
        }
    }

    useEffect(() => {
        if (isLastPage && lastContentSeen) {
            console.log('497 ultima pagina..')
            triggerCompletionIfNeeded()
        }
    }, [isLastPage, lastContentSeen])

    // Si el usuario navega hacia atrás o cambia de pantalla después de haber visto el último contenido,
    // completar igualmente el módulo y desbloquear el siguiente.
    useEffect(() => {
        // Asegurar que la actualización de estado se complete ANTES de abandonar la pantalla
        const beforeRemoveHandler = (e) => {
            try {
                if (lastContentSeen && !completionTriggeredRef.current) {
                    e.preventDefault()
                    ;(async () => {
                        try {
                            await triggerCompletionIfNeeded()
                        } catch {}
                        // Continuar con la navegación original
                        try {
                            navigation.dispatch(e.data.action)
                        } catch {}
                    })()
                } else {
                    // Si no hay nada pendiente, permitir salida normal
                }
            } catch {}
        }
        const unsubBeforeRemove = navigation.addListener(
            'beforeRemove',
            beforeRemoveHandler,
        )
        const unsubBlur = navigation.addListener('blur', () => {
            triggerCompletionIfNeeded()
        })
        return () => {
            try {
                unsubBeforeRemove && unsubBeforeRemove()
            } catch {}
            try {
                unsubBlur && unsubBlur()
            } catch {}
        }
    }, [navigation, lastContentSeen])

    // solo updatea los que no tienen evaluacion
    const updatear_status = async () => {
        console.log('1🍏 ------ updatear_status')
        const evaluation = item['evaluations'] ? item['evaluations'][0] : null
        const netInfoState = await NetInfo.fetch()
        const db = await openDB()
        let freshCourseItem
        if (isWeb) {
            freshCourseItem =
                currentModuleContext_store || currentCourse_store || courseItem
        } else {
            // freshCourseItem = courseItem
            freshCourseItem =
                currentModuleContext_store || currentCourse_store || courseItem
        }

        console.log(
            '1.1🍏 ------ updatear_status ~ freshCourseItem: ',
            freshCourseItem,
        )

        const current = find_current_module(freshCourseItem, item)
        // console.log('🚀 ~ file: CourseHome.jsx:567 ~ updatear_status ~ current:', current)
        console.log('2🍏 ------ updatear_status ~ current: ', current)
        console.log('3🍏 ------ updatear_status ~ evaluation: ', evaluation)

        if (!evaluation) {
            try {
                // console.log('el modulo no tiene evaluacion')
                console.log(
                    '4🍏 ------ updatear_status ~ el modulo no tiene evaluacion: ',
                )

                if (current.status !== LEARNING_STATUS.COMPLETED) {
                    const next_content = find_next_module(freshCourseItem, current)
                    // console.log('🚀 ~ file: CourseHome.jsx:574 ~ updatear_status ~ next_content:', next_content)
                    console.log(
                        '4🍏 ------ updatear_status ~ next_content: ',
                        next_content,
                    )

                    const payload = [
                        {
                            module: current,
                            status: LEARNING_STATUS.COMPLETED, // pasa el modulo actual a completo
                        },
                    ]

                    // paso el siguiente modulo si existe a pendiente
                    if (
                        next_content &&
                        next_content.status !== LEARNING_STATUS.COMPLETED &&
                        next_content.status !== LEARNING_STATUS.PENDIENTE
                    ) {
                        payload.push({
                            module: next_content,
                            status: LEARNING_STATUS.PENDIENTE,
                        })
                    }

                    console.log('5🍏 ------ updatear_status ~ payload: ', payload)

                    await update_status_local_content(payload) // aca mando modulos completos y pendientes

                    console.log('6🍏 ------ updatear_status ~ payload: ', payload)

                    try {
                        const updatedCourse = {
                            ...freshCourseItem,
                            moduls: freshCourseItem.moduls.map((m) => {
                                if (m._id?.toString() === current._id?.toString()) {
                                    return {
                                        ...m,
                                        status: LEARNING_STATUS.COMPLETED,
                                    }
                                }
                                if (
                                    next_content &&
                                    m._id?.toString() ===
                                        next_content._id?.toString() &&
                                    m.status !== LEARNING_STATUS.COMPLETED &&
                                    m.status !== LEARNING_STATUS.PENDIENTE
                                ) {
                                    return {
                                        ...m,
                                        status: LEARNING_STATUS.PENDIENTE,
                                    }
                                }
                                return m
                            }),
                        }

                        console.log(
                            '🍏 ------ updatear_status ~ updatedCourse: ',
                            updatedCourse,
                        )

                        // if (isWeb) {
                        setCurrentModuleContext_store(updatedCourse)
                        setCurrentCourse_store(updatedCourse)
                        // }
                    } catch {
                        console.error(
                            '🍏 ------ updatear_status ~ fallo actualizacion optimista store',
                        )
                    }

                    const update_moduls = [
                        {
                            module: current,
                            status: LEARNING_STATUS.COMPLETED,
                        },
                    ]
                    // Incluir también el siguiente módulo en estado PENDIENTE para que quede desbloqueado en DB/remote
                    if (
                        next_content &&
                        next_content.status !== LEARNING_STATUS.COMPLETED &&
                        next_content.status !== LEARNING_STATUS.PENDIENTE
                    ) {
                        update_moduls.push({
                            module: next_content,
                            status: LEARNING_STATUS.PENDIENTE,
                        })
                    }
                    console.log(
                        '7🍏 ------ updatear_status ~ update_moduls: ',
                        update_moduls,
                    )
                    console.log(
                        '7🍏 ------ updatear_status ~ freshCourseItem: ',
                        freshCourseItem,
                    )
                    //aca puedo validar si el curso esta completo y si el curso no tiene evaluacion final
                    let moduls_status = await module_structure_update(
                        db,
                        update_moduls,
                        freshCourseItem,
                    )

                    console.log(
                        '8🍏 ------ updatear_status ~ moduls_status: ',
                        moduls_status,
                    )

                    let status_course = freshCourseItem.status
                    if (
                        status_course != LEARNING_STATUS.COMPLETED &&
                        freshCourseItem.evaluations.length == 0
                    ) {
                        console.log('acaa actualizo status final de curso')
                        const isCompleted = moduls_status.every(
                            (module) => module.status === LEARNING_STATUS.COMPLETED,
                        )
                        console.log('🚀 ~ isCompleted:', isCompleted)
                        if (isCompleted) {
                            status_course = LEARNING_STATUS.COMPLETED
                        }
                    }

                    // console.log('freshCourseItem => ', JSON.stringify(freshCourseItem))

                    if (netInfoState.isConnected) {
                        const session = await fetchAuthSession()
                        const authToken = session.tokens.accessToken.toString()

                        const newStatusCourse = isCourseInProgress(
                            moduls_status,
                            status_course,
                            freshCourseItem,
                        )

                        const data = {
                            course_id: freshCourseItem._id,
                            course_status: newStatusCourse, // status_course,
                            moduls: JSON.stringify(moduls_status),
                            authToken: authToken,
                        }

                        const data_update_devices_users = {
                            authToken: authToken,
                            device_key: deviceId,
                            table: 'training_courses_caches',
                        }

                        const res = await save_progress_training_request(
                            data,
                            data_update_devices_users,
                        )
                        // Si el servidor confirmó el progreso, actualizar también el curso en la BD local
                        try {
                            if (res && (res.status === 1 || res.status === '1')) {
                                try {
                                    await update_course_local(
                                        db,
                                        freshCourseItem._id,
                                        newStatusCourse,
                                        res?.response?.single?.assessmentResult ??
                                            null,
                                    )
                                } catch (e) {
                                    // no bloquear flujo por error en persistencia local
                                    console.warn(
                                        'update_course_local failed after save_progress_training_request:',
                                        e,
                                    )
                                }
                            }
                        } catch (e) {}
                    } else {
                        console.log('no tenes conexion')
                        let progress_course = {
                            _id: freshCourseItem._id,
                            status: status_course,
                            moduls: JSON.stringify(moduls_status),
                        }
                        let save_progress_local = await save_progress_training_local(
                            db,
                            progress_course,
                        )
                        // console.log('🚀 111111 ~save_progress_local:', save_progress_local)

                        // get
                        //let get_progress_local = await get_progress_training_local(db)
                        // console.log('🚀 222222 ~get_progress_local:', get_progress_local)
                    }
                    // Refrescar UI con datos de DB para incluir también el siguiente módulo en PENDIENTE
                    try {
                        const refreshed = await get_course_by_id(
                            db,
                            freshCourseItem._id,
                        )
                        // setCurso(refreshed)
                        setCurrentCourse_store(refreshed)
                    } catch {}
                    try {
                        setReloadCounter((prevCounter) => prevCounter + 1)
                    } catch {}
                    try {
                        const { emitProgressUpdate } = require('./progressBus')
                        const payload = {
                            courseId: freshCourseItem._id,
                            updated: [
                                {
                                    moduleId: current._id,
                                    status: LEARNING_STATUS.COMPLETED,
                                },
                                ...(next_content &&
                                next_content.status !== LEARNING_STATUS.COMPLETED &&
                                next_content.status !== LEARNING_STATUS.PENDIENTE
                                    ? [
                                          {
                                              moduleId: next_content._id,
                                              status: LEARNING_STATUS.PENDIENTE,
                                          },
                                      ]
                                    : []),
                            ],
                        }
                        emitProgressUpdate(payload)
                    } catch {}
                }
            } catch (error) {
                console.error('Error al updatear status de modulo:', error) // TODO: ERROR
                throw new Error('Error al updatear status de modulo:', error)
            }
        } else {
            console.log('tiene evaluacion..............', item.status)
            // Asegurar dependencias locales y de red en este branch
            const netInfoState = await NetInfo.fetch()
            const db = await openDB()
            let authToken = null
            let data_update_devices_users = null
            try {
                const session = await fetchAuthSession()
                authToken = session.tokens.accessToken.toString()
                data_update_devices_users = {
                    authToken,
                    device_key: deviceId,
                    table: 'training_courses_caches',
                }
            } catch {}

            if (item.status == LEARNING_STATUS.PENDIENTE) {
                const payload = [
                    { module: item, status: LEARNING_STATUS.IN_PROGRESS },
                ]
                await update_status_local_content(payload)

                // Actualización optimista del estado local para reflejar IN_PROGRESS de inmediato
                try {
                    setCurso((prev) => {
                        try {
                            if (!prev || !Array.isArray(prev.moduls)) return prev
                            const updatedModuls = prev.moduls.map((m) => {
                                if (m._id?.toString() === item._id?.toString()) {
                                    return {
                                        ...m,
                                        status: LEARNING_STATUS.IN_PROGRESS,
                                    }
                                }
                                return m
                            })
                            return { ...prev, moduls: updatedModuls }
                        } catch {
                            return prev
                        }
                    })
                    try {
                        setReloadCounter((c) => c + 1)
                    } catch {}
                } catch {}

                // Actualizar estructura de módulos
                let moduls_status = await module_structure_update(
                    db,
                    payload,
                    freshCourseItem,
                )
                console.log(
                    '555555555555 ~ constupdatear_status= ~ moduls_status:',
                    moduls_status,
                )

                const newStatusCourse = isCourseInProgress(
                    moduls_status,
                    freshCourseItem.status,
                    freshCourseItem,
                )

                const data = {
                    course_id: freshCourseItem._id,
                    course_status: newStatusCourse, //freshCourseItem.status,
                    moduls: JSON.stringify(moduls_status),
                    authToken: authToken,
                }

                if (
                    netInfoState.isConnected &&
                    authToken &&
                    data_update_devices_users
                ) {
                    const res = await save_progress_training_request(
                        data,
                        data_update_devices_users,
                    )
                    console.log('6666666666~ constupdatear_status= ~ res:', res)
                    try {
                        if (res && (res.status === 1 || res.status === '1')) {
                            try {
                                await update_course_local(
                                    db,
                                    freshCourseItem._id,
                                    newStatusCourse,
                                    res?.response?.single?.assessmentResult ?? null,
                                )
                            } catch (e) {
                                console.warn(
                                    'update_course_local failed after save_progress_training_request (evaluation branch):',
                                    e,
                                )
                            }
                        }
                    } catch (e) {}
                }
                // Refrescar UI también cuando hay evaluación (pasa a IN_PROGRESS), desde DB
                try {
                    const refreshed = await get_course_by_id(db, freshCourseItem._id)
                    setCurrentCourse_store(refreshed)
                } catch {}
                try {
                    setReloadCounter((prevCounter) => prevCounter + 1)
                } catch {}
                try {
                    const { emitProgressUpdate } = require('./progressBus')
                    const payload = {
                        courseId: freshCourseItem._id,
                        updated: [
                            {
                                moduleId: item._id,
                                status: LEARNING_STATUS.IN_PROGRESS,
                            },
                        ],
                    }
                    emitProgressUpdate(payload)
                } catch {}
            }
        }
    }

    const isCourseInProgress = (modules, statusCourse, course = null) => {
        if (!modules || modules.length === 0) return statusCourse

        const hasCompletedModule = modules.some(
            (module) => module.status === LEARNING_STATUS.COMPLETED,
        )

        const allCompletedModules = modules.every(
            (module) => module.status === LEARNING_STATUS.COMPLETED,
        )

        console.log(
            '🚀 ~ hasCompletedModule:',
            hasCompletedModule,
            'allCompletedModules:',
            allCompletedModules,
        )

        // Algunos módulos completos pero no todos → en progreso
        if (hasCompletedModule && !allCompletedModules)
            return LEARNING_STATUS.IN_PROGRESS

        // Todos los módulos completos → verificar si hay evaluación final pendiente
        if (allCompletedModules && course?.evaluations?.length > 0) {
            const evaluation = course.evaluations[0]
            console.log('🚀 ~ evaluation:', evaluation)
            if (!evaluation.assessmentResult) {
                console.log(
                    '🚀 ~ El curso tiene evaluación final pendiente, mantener en progreso',
                )
                return LEARNING_STATUS.IN_PROGRESS
            }
        }

        return statusCourse
    }

    const handlePageChange = (isLastPage) => {
        setIsLastPage(isLastPage)
    }

    const handleEndReached = () => {
        setIsLastPage(true)
    }

    const handleNextModule = (index) => {
        const modulos = courseItem?.moduls
        if (modulos && index < modulos.length) {
            const nextModule = modulos[index]
            setNextModulData({
                _id: nextModule._id,
                content_type: nextModule.content_type,
                course_name: nextModule.course_name,
                description_long: nextModule.description_long || '',
                description_short: nextModule.description_short,
                likes: nextModule.likes,
                link_share: nextModule.link_share,
                media: nextModule.media,
                media_slides: nextModule.media_slides,
                status_liked: nextModule.status_liked,
                title: nextModule.title,
                users_comments: nextModule.users_comments,
                cover_image: nextModule.cover_image,
                status: nextModule.status,
                evaluations: nextModule.evaluations
            })
        } else {
            console.error('Error al obtener el próximo módulo.')
        }
    }

    // boton evaluarme o next content
    const NextModule = () => {
        // VALIDAR SI EL CONTENIDO TIENE EVALUACION, SI TIENE, MOSTRAR ESO Y QUE ME NAVEGUE A ESA VIEW
        // buscar el modulo actual
        // para encontrar la evaluacion que le pertenece a ese modulo
        // item = modulo actual
        // TODO el next Module estaba bloqueado para sync pendiente.. ? descomento para que se pueda evaluar
        // if (labelNextCourse === LABEL_STATE.label_course_pending) {
        //     return null
        // }
        const evaluation = item['evaluations'] ? item['evaluations'][0] : null

        const Evaluarme = () => {
            if (!isMobile) {
                return (
                    <TouchableOpacity
                        onPress={() =>
                            navigateNextContent(evaluation, nextModulData)
                        }
                        style={{ borderRadius: 15, overflow: 'hidden', flex: 0.5 }}
                    >
                        <LinearGradient
                            style={[
                                styles.container,
                                { paddingHorizontal: 16, paddingVertical: 6 },
                            ]}
                            colors={[
                                theme.colors.linearGradientEnd,
                                theme.colors.linearGradientStart,
                            ]}
                            start={{ x: 0, y: 0 }}
                            end={{ x: 1, y: 0 }}
                        >
                            <View
                                style={[
                                    styles.flexDirectionRow,
                                    { justifyContent: 'space-between' },
                                ]}
                            >
                                <Text
                                    style={{
                                        fontSize: 14,
                                        fontWeight: 'bold',
                                        color: 'white',
                                        alignSelf: 'center',
                                        textAlign: 'left',
                                    }}
                                    numberOfLines={2}
                                >
                                    {languageFile.evaluate_me}
                                </Text>

                                <Feather
                                    style={[
                                        styles.iconNextContent,
                                        { marginRight: 0 },
                                    ]}
                                    name='chevron-right'
                                    size={18}
                                    color={'white'}
                                />
                            </View>
                        </LinearGradient>
                    </TouchableOpacity>
                )
            } else {
                return (
                    <View
                        style={[
                            styles.invisibleContainer,
                            {
                                width: '95%',
                                marginBottom: isIOS() ? navBarHeight : 0,
                                borderRadius: 20,
                                overflow: 'hidden',
                                justifyContent: 'center',
                                alignSelf: 'center',
                            },
                        ]}
                    >
                        <TouchableOpacity
                            onPress={() =>
                                navigateNextContent(evaluation, nextModulData)
                            }
                        >
                            <LinearGradient
                                style={[
                                    styles.containerAlert,
                                    { paddingVertical: 10 },
                                ]}
                                colors={[
                                    theme.colors.linearGradientEnd,
                                    theme.colors.linearGradientStart,
                                ]}
                                start={{ x: 0, y: 0 }}
                                end={{ x: 1, y: 0 }}
                            >
                                <View style={[styles.feedbackAssetContainer]}>
                                    <Image
                                        style={[styles.feedbackAsset]}
                                        source={require('../../../assets/evaluations/evaluationContentAsset.png')}
                                    />
                                </View>

                                <View
                                    style={[
                                        styles.levelKnowledgeBlock2,
                                        { marginTop: 0 },
                                        {
                                            justifyContent: 'center',
                                            alignItems: 'flex-start',
                                        },
                                    ]}
                                >
                                    <View>
                                        <Text
                                            style={[
                                                styles.titleNextModule,
                                                {
                                                    color: 'white',
                                                },
                                            ]}
                                        >
                                            {languageFile.evaluate_me}
                                        </Text>

                                        <Text
                                            style={[
                                                styles.textDescription,
                                                {
                                                    color: 'white',
                                                },
                                            ]}
                                        >
                                            {nextModulData.title}
                                        </Text>
                                        {labelNextCourse ===
                                            LABEL_STATE.label_course_complete &&
                                            curso.certificate &&
                                            curso.certificate != '' && (
                                                <TouchableOpacity
                                                    style={styles.secondaryButton}
                                                    onPress={() =>
                                                        onPressCertificate(
                                                            curso.certificate,
                                                        )
                                                    }
                                                >
                                                    <Text
                                                        style={
                                                            styles.secondaryButtonText
                                                        }
                                                    >
                                                        {
                                                            languageFile.view_certificate
                                                        }
                                                    </Text>
                                                </TouchableOpacity>
                                            )}
                                    </View>
                                </View>
                                <Feather
                                    style={styles.iconButton}
                                    name='chevron-right'
                                    size={18}
                                    color={colorIcon}
                                />
                            </LinearGradient>
                        </TouchableOpacity>
                    </View>
                )
            }
        }

        const Next_content = () => {
            const { languageFile } = getLanguage()
            if (!isMobile) {
                if (!ultimate_module) {
                    return (
                        <TouchableOpacity
                            onPress={() => navigateNextContent(nextModulData)}
                            style={{
                                borderRadius: 15,
                                overflow: 'hidden',
                                flex: 0.5,
                            }}
                        >
                            <LinearGradient
                                style={[
                                    styles.container,
                                    { paddingHorizontal: 16, paddingVertical: 6 },
                                ]}
                                colors={[
                                    theme.colors.linearGradientEnd,
                                    theme.colors.linearGradientStart,
                                ]}
                                start={{ x: 0, y: 0 }}
                                end={{ x: 1, y: 0 }}
                            >
                                <View
                                    style={[
                                        styles.flexDirectionRow,
                                        { justifyContent: 'space-between' },
                                    ]}
                                >
                                    <Text
                                        style={{
                                            fontSize: 14,
                                            fontWeight: 'bold',
                                            color: 'white',
                                            textAlign: 'left',
                                        }}
                                        numberOfLines={2}
                                    >
                                        {languageFile.next_content}
                                    </Text>
                                    <Feather
                                        style={[
                                            styles.iconNextContent,
                                            { marginRight: 0 },
                                        ]}
                                        name='chevron-right'
                                        size={18}
                                        color={'white'}
                                    />
                                </View>
                            </LinearGradient>
                        </TouchableOpacity>
                    )
                } else {
                    return <></>
                }
            } else {
                if (!ultimate_module) {
                    return (
                        <View
                            style={[
                                [
                                    styles.invisibleContainer,
                                    {
                                        flex: 0,
                                        width: undefined,
                                        maxWidth: '90%',
                                        marginBottom: isIOS() ? navBarHeight : 0,
                                        borderRadius: 15,
                                        overflow: 'hidden',
                                        marginEnd: 12,
                                        alignSelf: 'flex-end',
                                    },
                                ],
                            ]}
                        >
                            <TouchableOpacity
                                style={{ width: '100%', flexShrink: 1 }}
                                onPress={() => navigateNextContent(nextModulData)}
                            >
                                <LinearGradient
                                    style={[styles.container, { flex: 0 }]}
                                    colors={[
                                        theme.colors.linearGradientEnd,
                                        theme.colors.linearGradientStart,
                                    ]}
                                    start={{ x: 0, y: 0 }}
                                    end={{ x: 1, y: 0 }}
                                >
                                    <View
                                        style={[
                                            styles.containerNextModule,
                                            {
                                                paddingVertical: 10,
                                                width: '100%',
                                                flexShrink: 1,
                                            },
                                        ]}
                                    >
                                        {/* Imagen */}
                                        <View
                                            style={styles.containerImageNextModule}
                                        >
                                            <Image
                                                style={styles.newImageNextModule}
                                                source={{
                                                    uri: nextModulData.cover_image
                                                        ? nextModulData.cover_image
                                                        : placeholderLearning,
                                                }}
                                            />
                                        </View>
                                        {/* Textos */}
                                        <View
                                            style={[
                                                { marginTop: 0 },
                                                {
                                                    flex: 0,
                                                    flexShrink: 1,
                                                },
                                            ]}
                                        >
                                            <Text
                                                style={[
                                                    styles.nextContent,
                                                    {
                                                        textAlign: 'left',
                                                        marginBottom: 5,
                                                        flex: 0,
                                                    },
                                                ]}
                                            >
                                                {languageFile.next_content}
                                            </Text>
                                            <Text
                                                style={[
                                                    styles.titleNextModuleBis,
                                                    { textAlign: 'left' },
                                                    { flex: 0 },
                                                ]}
                                                numberOfLines={2}
                                            >
                                                {nextModulData.title}
                                            </Text>
                                        </View>
                                        <Feather
                                            style={styles.iconNextContent}
                                            name='chevron-right'
                                            size={20}
                                            color={'white'}
                                        />
                                    </View>
                                </LinearGradient>
                            </TouchableOpacity>
                        </View>
                    )
                }
            }
        }

        const EvaluationCourse = () => {
            const { languageFile } = getLanguage()

            console.log('2---------voy a la evaluacion ') // curso.evaluations

            const handle_navigate = () => {
                // Helper robusto para extraer el ID de evaluación
                const getFirstEvaluationId = (course) => {
                    try {
                        let evals = course?.evaluations
                        if (typeof evals === 'string') {
                            try {
                                evals = JSON.parse(evals)
                            } catch {}
                        }
                        if (Array.isArray(evals) && evals.length > 0) {
                            const e0 = evals[0]
                            if (typeof e0 === 'string') return e0
                            if (e0 && (e0._id || e0.id))
                                return String(e0._id || e0.id)
                        }
                        const single = course?.evaluation || course?.evaluation_id
                        if (typeof single === 'string') return single
                        if (single && (single._id || single.id))
                            return String(single._id || single.id)
                        return null
                    } catch {
                        return null
                    }
                }

                const firstEvalId = getFirstEvaluationId(courseItem)
                if (!firstEvalId) {
                    console.warn(
                        '[CourseHome] No se encontró evaluationId en EvaluationCourse CTA; abortando navegación a Survey',
                    )
                    return
                }

                const courseToUse =
                    currentCourse_store || currentModuleContext_store || courseItem

                try {
                    // console.log('[CourseHome] Guardando curso en store antes de navegar a Survey:', courseToUse?._id)
                    setCurrentCourse_store(courseToUse)
                } catch (e) {
                    console.error('[CourseHome] Error al guardar curso en store:', e)
                }

                console.log(
                    '[DEBUG WEB CourseHome] Navegando a Survey desde EvaluationCourse CTA con evaluationId:',
                    firstEvalId,
                )
                navigation.navigate('Survey', {
                    evaluation: [firstEvalId],
                    next_content: null,
                    current_modul: {}, //currentCourse,
                    option: OPTIONS.OPTION_COURSE,
                    course_id: String(courseToUse?._id || ''),
                    courseItem: courseToUse,
                })
            }
            if (!isMobile) {
                return (
                    <TouchableOpacity
                        onPress={() => handle_navigate()}
                        style={{ borderRadius: 15, overflow: 'hidden', flex: 0.5 }}
                    >
                        <LinearGradient
                            style={[
                                styles.container,
                                { paddingHorizontal: 16, paddingVertical: 6 },
                            ]}
                            colors={[
                                theme.colors.linearGradientEnd,
                                theme.colors.linearGradientStart,
                            ]}
                            start={{ x: 0, y: 0 }}
                            end={{ x: 1, y: 0 }}
                        >
                            <View
                                style={[
                                    styles.flexDirectionRow,
                                    {
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        flex: 1,
                                    },
                                ]}
                            >
                                <Text
                                    style={{
                                        fontSize: 14,
                                        fontWeight: 'bold',
                                        color: 'white',
                                        includeFontPadding: false, // elimina padding extra en Android
                                        textAlignVertical: 'center', // centra verticalmente dentro del text
                                        textAlign: 'left',
                                    }}
                                >
                                    {languageFile.evaluate_me}
                                </Text>

                                <Feather
                                    style={[
                                        styles.iconNextContent,
                                        { marginRight: 0 },
                                    ]}
                                    name='chevron-right'
                                    size={18}
                                    color={'white'}
                                />
                            </View>
                        </LinearGradient>
                    </TouchableOpacity>
                )
            } else {
                return (
                    <View
                        style={[
                            styles.invisibleContainer,
                            {
                                width: '60%',
                                marginBottom: isIOS() ? navBarHeight : 0,
                                borderRadius: 20,
                                overflow: 'hidden',
                                justifyContent: 'center',
                                marginEnd: 20,
                                alignSelf: 'flex-end',
                            },
                        ]}
                    >
                        <TouchableOpacity
                            onPress={() => handle_navigate()}
                            style={{ flex: 1 }}
                        >
                            <LinearGradient
                                style={[styles.container]}
                                colors={[
                                    theme.colors.linearGradientEnd,
                                    theme.colors.linearGradientStart,
                                ]}
                                start={{ x: 0, y: 0 }}
                                end={{ x: 1, y: 0 }}
                            >
                                <View
                                    style={[
                                        styles.flexDirectionRow,
                                        { paddingVertical: 15 },
                                    ]}
                                >
                                    <View
                                        style={{
                                            height: '100%',
                                            backgroundColor: 'white',
                                            borderRadius: 10,
                                            marginStart: 12,
                                            width: 3,
                                        }}
                                    />
                                    <View
                                        style={[
                                            styles.levelKnowledgeBlock,
                                            {
                                                justifyContent: 'center',
                                                alignItems: 'flex-start',
                                                marginStart: 12,
                                            },
                                        ]}
                                    >
                                        <View>
                                            <Text
                                                style={[
                                                    styles.titleNextModuleBis,
                                                    {
                                                        textAlign: 'left',
                                                        fontWeight: 'normal',
                                                        marginBottom: 5,
                                                    },
                                                ]}
                                            >
                                                {'Evaluación'}
                                            </Text>
                                            <Text
                                                style={[
                                                    styles.nextContent,
                                                    {
                                                        textAlign: 'left',
                                                        fontWeight: '700',
                                                    },
                                                ]}
                                                numberOfLines={2}
                                                ellipsizeMode='tail'
                                            >
                                                {courseItem.evaluations &&
                                                courseItem.evaluations[0] &&
                                                courseItem.evaluations[0].name
                                                    ? courseItem.evaluations[0].name
                                                    : ''}
                                            </Text>
                                        </View>
                                    </View>
                                    <Feather
                                        style={styles.iconNextContent}
                                        name='chevron-right'
                                        size={20}
                                        color={'white'}
                                    />
                                </View>
                            </LinearGradient>
                        </TouchableOpacity>
                    </View>
                )
            }
        }

        if (evaluation) {
            if (item.status === LEARNING_STATUS.COMPLETED) {
                // muestro siguiente contenido
                return <Next_content />
            } else {
                return <Evaluarme />
                // muestro boton evaluacion
            }
        } else {
            // muestro siguiente contenido

            if (!ultimate_module) {
                return <Next_content />
            } else {
                if (
                    courseItem.evaluations &&
                    courseItem.evaluations.length > 0 &&
                    courseItem.status !== LEARNING_STATUS.COMPLETED
                ) {
                    return <EvaluationCourse />
                } else {
                    return <Next_content />
                }
            }
        }
    }

    const navigateNextContent = (route, data, isBack) => {
        console.log('Navigation to next content:', { route, data, isBack })
        setLastContentSeen(false)
        if (isBack) {
            //voy al curso
            // navigation.navigate('Course', {
            //     item: currentModuleContext_store,
            //     array_cursos: [],
            // })
            navigation.goBack()
        } else {
            if (data) {
                const courseToUse =
                    currentCourse_store || currentModuleContext_store || courseItem
                try {
                    setCurrentCourse_store(courseToUse)
                } catch (e) {
                    console.error('[Module] Error al guardar curso en store:', e)
                }

                // 1) Ir al Home del curso en segundo plano para que, al cerrar el modal, quedemos allí
                try {
                    navigation.navigate('Course', {
                        item: courseToUse,
                        array_cursos: [],
                    })
                } catch {}
                // 2) Abrir la evaluación como modal por encima
                setTimeout(() => {
                    try {
                        console.log(
                            '[DEBUG WEB CourseHome] Navegando a Survey desde módulo con evaluationId:',
                            route,
                        )
                        navigation.navigate('Survey', {
                            evaluation: [route], // para evaluacion en modulo
                            next_content: data,
                            current_modul: item,
                            option: OPTIONS.OPTION_MODULE,
                            course_id: String(courseToUse?._id || ''),
                            courseItem: courseToUse,
                        })
                    } catch {}
                }, 0)
            } else {
                navigation.navigate('Module', {
                    item: route,
                    courseItem: courseItem,
                    labelNextCourse: labelNextCourse,
                })
            }
        }
    }

    const handleCompleteSurvey = (id) => {
        //    update_complete_local_posts(id, true);
    }

    const evaluateMe = () => {
        //@LAU: lógica del botón
    }

    const pendingAsset = require('../../../assets/cloudCheck.png')
    const downloadedAsset = require('../../../assets/cloudCheck.png')
    const [showDownloadButton, setShowDownloadButton] = useState(false)
    const [contentDownloaded, setContentDownloaded] = useState(false)
    const [loading, setLoading] = useState(false)
    const { openBottomSheet } = useBottomSheet()
    const { closeBottomSheet } = useBottomSheet()
    const snapPoints = ['60%']

    let path = `courses/${courseItem._id}`

    useEffect(() => {
        const checkContent = async () => {
            if (!item) {
                return
            }
            let url = item.media_slides

            let contents = url.flatMap((item) => {
                return item.media
            })

            if (contents.length > 0) {
                const ImageName = getNameUrl(contents[0])
                const exist = await searchFilebyName(ImageName, 'unzipped/' + path)

                if (!exist) {
                    setContentDownloaded(false)
                    setShowDownloadButton(true)
                    return
                }

                setContentDownloaded(true)
                setShowDownloadButton(false)
            }
        }

        checkContent()
    }, [item])

    const downloadModule = async () => {
        const netInfoState = await NetInfo.fetch()

        if (!netInfoState.isConnected) {
            console.error('No hay conexión a internet, no podes descargar el modulo')
            return
        }

        setLoading(true)
        setKeepAwake('active')

        let image = require('../../../assets/circleLoader.gif')
        let title = languageFile.content_download_in_process
        let description = languageFile.content_is_downloading

        openBottomSheet(
            <ModalDownloadCourse
                image={image}
                title={title}
                description={description}
                button={false}
                buttonDelete={false}
                buttonCancel={false}
                closeBottomSheet={closeBottomSheet}
            />,
            undefined,
            false,
            false,
            false,
        )

        try {
            let url = item.media_slides

            let contents = url.flatMap((item) => {
                return item.media
            })

            let downloadedContent = await downloadContent(path, contents)

            if (!downloadedContent) {
                console.log('Hubo un error al descargar')
                setShowDownloadButton(true)
                setContentDownloaded(false)
                return
            }

            let image = require('../../../assets/downloadCourse.png')
            let title = languageFile.downloaded_content
            let description = languageFile.you_can_train_offline

            openBottomSheet(
                <ModalDownloadCourse
                    image={image}
                    title={title}
                    description={description}
                    button={true}
                    buttonDelete={false}
                    buttonCancel={false}
                    closeBottomSheet={closeBottomSheet}
                />,
            )
            setShowDownloadButton(false)
            setContentDownloaded(true)
        } catch (error) {
            console.error('Error downloading course:', error)
            setContentDownloaded(false)
        } finally {
            setKeepAwake('desactive')
            closeBottomSheet(true)
            setLoading(false)
        }
    }

    const [courseDeleted, setCourseDeleted] = useState(false)

    const deleteModule = async () => {
        let image = require('../../../assets/deleteCourse.png')
        let title = languageFile.delete_offline_content
        let description = languageFile.not_view_content_offline

        openBottomSheet(
            <ModalDownloadCourse
                image={image}
                title={title}
                description={description}
                button={true}
                buttonDelete={false}
                buttonCancel={true}
                closeBottomSheet={closeBottomSheet}
                courseDeleted={() => deletedModule()}
            />,
        )
    }

    const deletedModule = async () => {
        setLoading(true)

        try {
            let url = item.media_slides

            let contents = url.flatMap((item) => {
                return item.media
            })

            if (contents.length > 0) {
                const ImageName = getNameUrl(contents[0])
                const directoryUri = `${documentDirectory}unzipped/${path}/${ImageName}`

                await deletePathFile(directoryUri)
            }

            let image = require('../../../assets/deletedCourse.png')
            let title = languageFile.content_is_not_available
            let description = languageFile.not_available_offline
            openBottomSheet(
                <ModalDownloadCourse
                    image={image}
                    title={title}
                    description={description}
                    button={true}
                    buttonDelete={false}
                    buttonCancel={false}
                    closeBottomSheet={closeBottomSheet}
                    courseDeleted={courseDeleted}
                />,
            )
            setShowDownloadButton(true)
            setContentDownloaded(false)
        } catch (error) {
            console.error('Error deleting course:', error)
        } finally {
            setLoading(false)
        }
    }
    const bp = useBreakpoint()
    const isMobile = bp === 'sm'

    return (
        <View style={styles.containerModule}>
            <ScrollView showsVerticalScrollIndicator={false}>
                <View
                    style={{ flex: 1, flexDirection: isMobile ? 'column' : 'row' }}
                >
                    <View
                        style={[
                            { flexDirection: 'row', paddingHorizontal: 12 },
                            !isMobile && {
                                flex: 0.4,
                                paddingStart: 12,
                                paddingEnd: 36,
                            },
                        ]}
                    >
                        <View style={{ flex: 1 }}>
                            {/* boton de navegacion que muestra el nombre del curso */}
                            <TouchableOpacity
                                onPress={() => {
                                    isWeb
                                        ? navigateNextContent(
                                              nextModulData,
                                              null,
                                              true,
                                          )
                                        : navigation.goBack()
                                }}
                            >
                                <View style={styles.courseNameModule}>
                                    {!isMobile && (
                                        <Feather
                                            style={[
                                                styles.iconNextContent,
                                                { marginRight: 12 },
                                            ]}
                                            name='chevron-left'
                                            size={18}
                                            color={theme.colors.darkGray}
                                        />
                                    )}
                                    <Text
                                        style={styles.titleCourseInModule}
                                        numberOfLines={2}
                                    >
                                        {courseItem.title.toUpperCase()}
                                    </Text>
                                </View>
                            </TouchableOpacity>
                            <View style={styles.spacer}></View>
                            {/* contenedor del titulo del modulo */}

                            {item.title && (
                                <Text
                                    style={[
                                        styles.titleModule,
                                        {
                                            paddingHorizontal: 0,
                                            paddingVertical: 0,
                                            paddingBottom: 10,
                                        },
                                        !isMobile && { marginTop: 16 },
                                    ]}
                                    numberOfLines={3}
                                >
                                    {item.title}
                                </Text>
                            )}
                            {!isMobile && (
                                <View
                                    style={[
                                        styles.containerDescription,
                                        { paddingHorizontal: 0 },
                                    ]}
                                >
                                    {item.description_short && (
                                        <RenderHTML
                                            source={{ html: item.description_short }}
                                            baseStyle={{
                                                fontSize: 15,
                                                fontWeight: 'normal',
                                                color: theme.colors.textSecondary,
                                                marginBottom: 20,
                                            }}
                                        />
                                    )}
                                    {!isMobile && (
                                        <View style={{ flexDirection: 'row' }}>
                                            <TouchableOpacity
                                                onPress={() =>
                                                    navigateNextContent(
                                                        nextModulData,
                                                        null,
                                                        true,
                                                    )
                                                }
                                                style={{
                                                    borderRadius: 15,
                                                    overflow: 'hidden',
                                                    borderColor:
                                                        theme.colors.colorPrimary,
                                                    borderWidth: 1,
                                                    flex: 0.5,
                                                }}
                                            >
                                                <LinearGradient
                                                    style={[
                                                        styles.container,
                                                        {
                                                            paddingHorizontal: 16,
                                                            paddingVertical: 6,
                                                        },
                                                    ]}
                                                    colors={['white', 'white']}
                                                    start={{ x: 0, y: 0.5 }}
                                                    end={{ x: 1, y: 0.5 }}
                                                >
                                                    <View
                                                        style={[
                                                            styles.flexDirectionRow,
                                                            {
                                                                justifyContent:
                                                                    'space-between',
                                                            },
                                                        ]}
                                                    >
                                                        <Feather
                                                            style={[
                                                                styles.iconNextContent,
                                                                { marginRight: 0 },
                                                            ]}
                                                            name='chevron-left'
                                                            size={18}
                                                            color={
                                                                theme.colors
                                                                    .colorPrimary
                                                            }
                                                        />

                                                        <Text
                                                            style={{
                                                                // marginStart: 20,
                                                                fontSize: 14,
                                                                fontWeight:
                                                                    'regular',
                                                                color: theme.colors
                                                                    .colorPrimary,
                                                                maxWidth: 60,
                                                                textAlign: 'right',
                                                            }}
                                                            numberOfLines={2}
                                                        >
                                                            {'Volver a curso'}
                                                        </Text>
                                                    </View>
                                                </LinearGradient>
                                            </TouchableOpacity>
                                            <View style={{ width: 12 }} />
                                            {isLastPage && lastContentSeen && (
                                                <NextModule />
                                            )}
                                        </View>
                                    )}
                                </View>
                            )}
                        </View>
                        {contentDownloaded && (
                            <View style={{ flex: 1, paddingRight: 10 }}>
                                <View
                                    //onPress={() => deleteModule()}
                                    style={styles.containerCloudCheck}
                                >
                                    <Image
                                        style={{ width: 24, height: 24 }}
                                        tintColor={theme.colors.colorApproved}
                                        source={pendingAsset}
                                    />
                                </View>
                            </View>
                        )}
                    </View>

                    <View style={{ flex: 1 }}>
                        {item.media_slides && item.media_slides.length > 0 && (
                            <MediaComponent
                                medias={item.media_slides}
                                onPageChange={handlePageChange}
                                onEndReached={handleEndReached}
                                key={item._id}
                                handleCompleteSurvey={handleCompleteSurvey}
                                autoplay={true}
                                contentSeen={() => {
                                    // Marcar inmediatamente el último contenido como visto y la página como última
                                    // para evitar carreras entre onPageChange(true) y el setLastContentSeen(true)
                                    try {
                                        setLastContentSeen(true)
                                    } catch {}
                                    try {
                                        setIsLastPage(true)
                                    } catch {}
                                }}
                                // Activamos modo learning explícito
                                path={'learning'}
                                // Clave de reanudación persistente por módulo/curso
                                // Nota: evitamos usar una variable 'index' no definida en este scope
                                resumeKey={
                                    item?._id ||
                                    item?.slug ||
                                    `${item?.title || 'module'}`
                                }
                                // Auto avanzar al siguiente slide cuando termina un video
                                autoAdvanceOnVideoEnd={true}
                                // Countdown de 5 segundos antes del autoplay del video
                                countdownSeconds={5}
                                isVisible={true}
                                // Completar inmediatamente si es el último módulo del curso
                                isUltimateModule={ultimate_module}
                                onLastContentSeen={() => {
                                    try {
                                        if (!completionTriggeredRef.current) {
                                            completionTriggeredRef.current = true
                                            updatear_status().catch(() => {})
                                        }
                                    } catch {}
                                }}
                            />
                        )}
                    </View>

                    {isMobile && (
                        <View style={styles.containerDescription}>
                            {item.description_short && (
                                <RenderHTML
                                    source={{ html: item.description_short }}
                                    baseStyle={styles.descriptionModule}
                                />
                            )}
                            <View style={styles.spacer2}></View>
                        </View>
                    )}
                </View>
            </ScrollView>

            {isMobile && isLastPage && lastContentSeen && <NextModule />}
        </View>
    )
}

export const normalizeCourse = (course) => {
    if (!course) return null

    try {
        const normalized = { ...course }

        // Parsear moduls
        if (typeof normalized.moduls === 'string') {
            try {
                normalized.moduls = JSON.parse(normalized.moduls)
            } catch (e) {
                console.warn('[CourseHome] Error parsing moduls:', e)
                normalized.moduls = []
            }
        }

        // Asegurar array
        if (!Array.isArray(normalized.moduls)) {
            normalized.moduls = []
        }

        // Parsear evaluations
        if (typeof normalized.evaluations === 'string') {
            try {
                normalized.evaluations = JSON.parse(normalized.evaluations)
            } catch (e) {
                normalized.evaluations = []
            }
        }

        return normalized
    } catch (error) {
        console.error('[CourseHome] Error normalizing course:', error)
        return course
    }
}

export default CourseHome
